(function () {
  'use strict';
  angular
    .module('frontendApp',
    [ 'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'LocalStorageModule',
      'sap.imageloader',
      'angular-inview',
      'ngMap',
      'fox.scrollReveal',
      'angularSmoothscroll',
      'angular-owl-carousel-2'
    ]);

})();

'use strict';
angular
  .module('frontendApp')
  .factory('TablesService', function ($http, $rootScope) {
    return {
      listar: function (tabla) {
        var params = [];
        //params['lan'] = 'en';
        return $http.get($rootScope.api + '/api/' + tabla, params);
      },
      filtrar: function (tabla, params) {
        params['lan'] =   $rootScope.language;
        return $http.post($rootScope.api + '/api/' + tabla + '/filtrar', params);
      },
      contactar: function (params) {
        params['lan'] = $rootScope.language != undefined ? $rootScope.language : 'en';
        return $http.post($rootScope.api + '/api/formcontacto/almacenar', params);
      },
      visualizar: function (tabla, id) {
        var params = {
          'token': $rootScope.tk,
          'lan': $rootScope.language != undefined ? $rootScope.language : 'en'
        };
        return $http.get($rootScope.api + '/api/' + tabla + '/visualizar/' + id, params);
      }
    };
  });

(function () {
  'use strict';
  angular
    .module('frontendApp')
    .directive('boucle', function ($rootScope, $timeout) {
      return {
        restrict: 'A',
        scope:{
          index:'=',
          alldata:'=',
        },
        rootScope: $rootScope,
        link: function (scope, element, rootScope) {
          $(window).resize(function () {
            //transform: rotateY(0deg) translateZ(500px)
            element.css({webkitTransform:"rotateY("+scope.index*(360/scope.alldata)+"deg) translateZ(500px)"  });
            if(scope.index*(360/scope.alldata)> 180){
             // element.css({backgroundColor: 'red' });
            }
            //element.css.webkitTransform = 'scale(5)';
            //element.css.webkitTransform = "rotateY("+scope.index*(360/scope.alldata)+"deg) translateZ(500px)";
            console.log(scope.index,(360/scope.alldata), scope.index*(360/scope.alldata))
          }).resize();
        }
      };
    })
})();

(function () {
  'use strict';
  angular
    .module('frontendApp')
    .directive("countTo", ["$timeout", function (a) {
      return {
        replace: !1, scope: !0, link: function (b, c, d) {
          var e, f, g, h, i, j, k, l = c[0], m = function () {
            f = 30, i = 0, b.timoutId = null, j = parseInt(d.countTo) || 0, b.value = parseInt(d.value, 10) || 0, g = 1e3 * parseFloat(d.duration) || 0, h = Math.ceil(g / f), k = (j - b.value) / h, e = b.value
          }, n = function () {
            b.timoutId = a(function () {
              e += k, i++, i >= h ? (a.cancel(b.timoutId), e = j, l.innerText = j) : (l.innerText = Math.round(e), n())
            }, f)
          }, o = function () {
            b.timoutId && a.cancel(b.timoutId), m(), n()
          };
          return d.$observe("countTo", function (a) {
            a && o()
          }), d.$observe("value", function () {
            o()
          }), !0
        }
      }
    }])
    .directive('height100', function ($log) {
      return {
        restrict: 'C',
        link: function (scope, element) {
          $log.debug('Aplicando directiva height');
          $(window).resize(function () {
            element.css({"height": $(window).height()});
          }).resize();
        }
      };
    })
    .directive('listaMenu', function ($log) {
      return {
        restrict: 'C',
        link: function (scope, element) {
          $(window).resize(function () {
            if($(window).width()<779){
              element.css({"maxHeight": $(window).height() - 60});
            }else{
              element.css({"maxHeight": 'none'});
            }
          }).resize();
        }
      };
    })
    .directive('proporcion', function ($log, $timeout) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var conf = scope.$eval(attrs.proporcion);
          //$log.debug('Config', conf);
          var calcProp = function () {
            if((!conf.desde && !conf.hasta) || ($(window).width()>conf.desde && $(window).width()<=conf.hasta)){
              var eW = element[0].getBoundingClientRect().width;
              var nW = eW / conf.ancho;
              var nH = nW * conf.alto;
              element.css('height', nH + 'px');
            }else{
              if(conf.default){
                element.css('height', conf.default + 'px');
              }else{
                element.css('height', 'initial');
              }
            }
          };
          $timeout(function () {
            calcProp();
          }, 10);
          angular.element(window).resize(function () {
            $timeout(function () {
              calcProp();
            }, 10);
          });
        }
      };
    })
    .controller('indDropDownCtrl', function ($log, $timeout, $scope) {
      $scope.hideDesp = function () {
        $timeout(function () {
          $scope.showDesp = false;
        }, 30);
        $scope.showDesp = false;
      };
      $scope.selOpcion = function (elem) {
        $scope.opselected = elem;
        $timeout(function () {
          $scope.onselect();
          $scope.hideDesp();
        }, 30);
      };
    })
    .directive('igualar2', function ($log, $timeout) {
      return {
        restrict: 'C',
        link: function (scope, element, attrs) {
          var igualar = function(){
            var eH = 0;
            var col = '';
            if(element.children('.izq')[0].getBoundingClientRect().height>element.children('.der')[0].getBoundingClientRect().height){
              eH = element.children('.izq')[0].getBoundingClientRect().height;
              col = element.children('.der')[0];
            }else{
              eH = element.children('.der')[0].getBoundingClientRect().height;
              col = element.children('.izq')[0];
            }
            if($(window).width()>992){
              col.style.height = eH + 'px';
            }else{
              element.children('.izq')[0].style.height = 'auto';
              element.children('.der')[0].style.height = 'auto';
            }
          };
          $timeout(function() {
            igualar();
          }, 30);
          angular.element(window).resize(function () {
            $timeout(function() {
              igualar();
            }, 30);
          });
        }
      };
    })
    .directive('indDropDown', function ($log, $timeout, $compile) {
      return {
        restrict: 'C',
        controller: 'indDropDownCtrl',
        scope: {
          opciones: "=",
          onselect: "&",
          opselected: "=",
          txdefault: "@",
          campotx: "@"
        },
        link: function (scope, element, attrs) {
          var template = '<div class="ind-desplegable" deep-blur="hideDesp();">' +
            '<label class="deplegar-lista" data-ng-click="showDesp = !showDesp" data-ng-class="{active: showDesp}">' +
            '<a><span data-ng-if="!opselected" data-ng-bind="txdefault" class="dropdown-placeholder"></span>' +
            '<span data-ng-if="opselected" data-ng-bind="opselected[campotx]"></span></a><span></span></label>' +
            '<ul data-ng-if="showDesp" class="lista-elegir">' +
            '<li data-ng-repeat="d in opciones" data-ng-click="selOpcion(d);"><span data-ng-bind="d[campotx]"></span></li></ul></div>';
          var content = $compile(template)(scope);
          element.replaceWith(content);
          /*attrs.$observe('opselected', function (val) {
           element.replaceWith(content);
           });*/
        }
      };
    })
    .directive('indDropDownClean', function ($log, $timeout, $compile) {
      return {
        restrict: 'C',
        controller: 'indDropDownCtrl',
        scope: {
          opciones: "=",
          onselect: "&",
          opselected: "=",
          txdefault: "@",
          campotx: "@"
        },
        link: function (scope, element, attrs) {
          var template = '<div class="ind-desplegable" deep-blur="hideDesp();">' +
            '<label class="deplegar-lista" data-ng-click="showDesp = !showDesp" data-ng-class="{active: showDesp}">' +
            '<a><span data-ng-if="!opselected" data-ng-bind="txdefault"></span>' +
            '<span data-ng-if="opselected" data-ng-bind="opselected[campotx]"></span></a><span></span></label>' +
            '<ul data-ng-if="showDesp" class="lista-elegir">' +
            '<li data-ng-repeat="d in opciones" data-ng-click="selOpcion(d);"><span data-ng-bind="d"></span></li></ul></div>';
          var content = $compile(template)(scope);
          element.replaceWith(content);
          /*attrs.$observe('opselected', function (val) {
           element.replaceWith(content);
           });*/
        }
      };
    })
    .directive('deepBlur', ['$timeout', function ($timeout) {
      return {
        restrict: 'A',
        controller: [ '$scope', '$element', '$attrs', '$log', function ($scope, $element, $attrs, $log) {
          function containsDom(parent, dom) {
            while (dom) {
              if (dom === parent) {
                return true;
              }
              dom = dom.parentNode;
            }
            return false;
          }
          var leaveExpr = $attrs.deepBlur,
            dom = $element[0];
          function onBlur(e) {
            var targetElement = e.relatedTarget || document.activeElement;
            if (!containsDom(dom, targetElement)) {
              $timeout(function () {
                $scope.$apply(leaveExpr);
              }, 30);
            }
          }
          if (dom.addEventListener) {
            dom.addEventListener('blur', onBlur, true);
          } else {
            dom.attachEvent('onfocusout', onBlur);
          }
        } ]
      };
    }])
    .directive('pagina', function ($log, $timeout) {
      return {
        restrict: 'C',
        link: function (scope, element) {
          $(window).resize(function () {
            if($(window).width()>992){
              element.css({minHeight: $(window).height() - 60});
            }else{
              $timeout(function () {
                element.css({minHeight: $(window).height() - $('.footer').height()-30});
              }, 30);
            }
          }).resize();
        }
      };
    })
    .directive('contIgualar', function ($log, $timeout) {
      return {
        restrict: 'C',
        scope: {
          elementos: "@",
          columnas: "@",
          reload: "@",
          maxheight: "@"
        },
        link: function (scope, element, attrs) {
          //var elems = document.getElementsByClassName(scope.elementos);
          var columnas = parseInt(scope.columnas);
          var igualar = function () {
            if ($(window).width() > 768) {
              $timeout(function () {
                var elems = element.children('.' + scope.elementos);
                var eigualar = [];
                for (var i = 1; i <= elems.length; i++) {
                  if (i % columnas == 0) {
                    eigualar.push(elems[i - 1]);
                    var mh = 0;
                    angular.forEach(eigualar, function (value, key) {
                      if (value.getBoundingClientRect().height > mh) {
                        if(scope.maxheight){
                          mh = value.getBoundingClientRect().width - (value.getBoundingClientRect().width / 10);
                        }else{
                          mh = value.getBoundingClientRect().height;
                        }
                      }
                    });
                    angular.forEach(eigualar, function (value, key) {
                      value.style.height = mh + "px";
                    });
                    eigualar = []
                  } else {
                    eigualar.push(elems[i - 1]);
                  }
                }
                var mh2 = 0;
                angular.forEach(eigualar, function (value, key) {
                  if (value.getBoundingClientRect().height > mh2) {
                    mh2 = value.getBoundingClientRect().height;
                  }
                });
                angular.forEach(eigualar, function (value, key) {
                  value.style.height = mh2 + "px";
                });
              }, 30);
            }
          };
          angular.element(window).resize(function () {
            var elems = element.children('.' + scope.elementos);
            angular.forEach(elems, function (value, key) {
              value.style.height = "initial";
            });
            igualar();
          });
          igualar();
          var reigualar = function(){
            var elems = element.children('.' + scope.elementos);
            angular.forEach(elems, function (value, key) {
              value.style.height = "initial";
            });
            $timeout(function () {
              $log.debug('Volviendo a igualar');
              igualar();
            }, 30);
          };
          if(scope.reload){
            //$log.debug('Volver a igualar');
            var imageswait = element.find("img");
            $log.debug('cantidad de imagenes', imageswait);
            var countload = 0;
            angular.forEach(imageswait, function (value, key) {
              value.onload = function () {
                //$log.debug('Imagen '+key+' cargada');
                countload++;
                if(countload==imageswait.length){
                  reigualar();
                }
              };
            });
          }
        }
      }
    })
    .directive('paginaprod', function ($log, $timeout) {
      return {
        restrict: 'C',
        link: function (scope, element) {
          $(window).resize(function () {
              element.css({height: $(window).height() - 60});
              element.css({paddingTop: 70});
              element.css({overflowY: "scroll"});
          }).resize();
        }
      };
    })
    .directive('windowheight', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
          }).resize();
        }
      };
    })
    .directive('bottomMenu', function () {
      return {
        restrict: 'C',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()-80});
          }).resize();
        }
      };
    })
    .directive('slideralbum', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()-70});
          }).resize();
        }
      };
    })
    .directive('sliderhome', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()-140});
            element.css({maxHeight: $(window).height()-140});
            element.css({overflow: 'hidden'});
          }).resize();
        }
      };
    })
    .directive('bottomHeight', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {

          $(window).resize(function () {
            var heigth = Math.round(($(window).height()/3) - ((130/3))  );
            //element.css({minHeight: heigth * 1});
            if($(window).width()>=768){
              element.css({minHeight: heigth * 1});
            }
            else{
              element.css({minHeight: 320});
            }
          }).resize();
        }
      };
    })
    .directive('bottomHeight2', function () {
      return {
        restrict: 'A',
        scope:{
          background:'@'
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var heigth = Math.round(($(window).height()/3) - ((130/3)));

            element.css({background: "url('"+scope.background+"')"});
            element.css({backgroundSize: "cover"});
            element.css({backgroundPosition: "center"});
            if($(window).width()>=768){
              element.css({minHeight: heigth * 1});
            }
            else{
              element.css({minHeight: 250});
            }
          }).resize();
        }
      };
    })
    .directive('sliderservices', function ($rootScope, $timeout) {
      return {
        restrict: 'A',
        scope:{
          items:'=',
          alldata:'=',
        },
        rootScope: $rootScope,
        link: function (scope, element, rootScope) {
          //console.log('desde directiva1 ', scope.items);
          scope.itemSize = 120;
          $(window).resize(function () {
            var clientW = $(window).width();
            var size = 0;
            size = scope.items*120+120+(120/2);
            element.css({width: size});
          }).resize();
        },
        controller:function($scope, $rootScope, $timeout, $window){
          $(window).resize(function () {
            var clientW = $(window).width();
            var size = 0;
            var max = 0;
            $scope.itemSize = 120;
            $rootScope.sliderOp = {};
            $rootScope.sliderOp.perView = Math.floor((clientW - $scope.itemSize)/$scope.itemSize);
            console.log('elementos visibles 0', $rootScope.sliderOp.perView)
            if($rootScope.sliderOp.perView % 2 == 1){
              size = $scope.items*$scope.itemSize+$scope.itemSize;
            }
            else{
              $scope.itemSize = 120 + Math.round(($scope.itemSize/($rootScope.sliderOp.perView-1))) ;
              var perView = Math.round((clientW - $scope.itemSize)/$scope.itemSize);
              $scope.margin = Math.round( (  $scope.itemSize/perView)/2 );
              size = $scope.items*$scope.itemSize+$scope.itemSize;
            }
            //$rootScope.sliderOp.pos = (-1)*Math.round($scope.items/2)*$scope.itemSize;
            $rootScope.sliderOp.pos = 0;
            if($rootScope.sliderOp.perView !=1){
              $rootScope.sliderOp.current =  Math.round($rootScope.sliderOp.perView/2)-1;
            }
            else{
              //for responive xs
              $rootScope.sliderOp.current = 1;
              $rootScope.sliderOp.pos = -120;
            }

            $rootScope.sliderOp.move = function(value, index){
              console.log('avanza', (size + $rootScope.sliderOp.pos -$scope.itemSize), clientW)
              switch (value) {
                case 'forward':
                  if ((size + $rootScope.sliderOp.pos ) > (clientW )) {
                    $rootScope.sliderOp.pos -= $scope.itemSize ;
                    $rootScope.sliderOp.current++;

                    //$timeout($rootScope.sliderOp.move, 6000);
                  }
                  break;
                case 'backward':
                  if ($rootScope.sliderOp.pos <= -$scope.itemSize){
                    $rootScope.sliderOp.pos += $scope.itemSize ;
                    $rootScope.sliderOp.current--;
                  }
                  break;
                default:
                  $rootScope.sliderOp.pos = (value - (Math.round($rootScope.sliderOp.perView/2)-1))*$scope.itemSize*(-1) ;
                  $rootScope.sliderOp.current = value;
                  break;
              }
            };
           // $timeout($rootScope.sliderOp.move, 6000);
          }).resize();
        }
      };
    })
    .directive('itemserv', function ($rootScope) {
      return {
        restrict: 'A',
        scope:{
          items:'='
        },
        rootScope: $rootScope,
        link: function (scope, element, rootScope, $timeout) {
          $(window).resize(function () {
            var clientW = $(window).width();
            scope.itemSize = 120;
            scope.perView = Math.floor((clientW - scope.itemSize)/scope.itemSize);
            //console.log('elementos visibles', scope.perView)
            if(scope.perView % 2 == 1 ){
              element.css({marginLeft: 0});
              element.css({marginRight:0});
            }
            else{
              var itemSize = 120 + Math.round((scope.itemSize/(scope.perView-1))) ;
              var perView = Math.round((clientW - scope.itemSize)/scope.itemSize);
              scope.margin = Math.round( (itemSize/perView)/2 );
              element.css({marginLeft: scope.margin });
              element.css({marginRight:scope.margin });
            }
          }).resize();
        },
      };
    })
    .directive('triangle', function ($log, $timeout, $compile) {
      return {
        restrict: 'C',
        link: function (scope, element, attrs) {
          var wcont = element.parent()[0].getBoundingClientRect().width;
          var hcont = element.parent()[0].getBoundingClientRect().height;
          $timeout(function () {
            var template = '<span class="triangle"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 '+wcont+' 40" ' +
              'style="enable-background:new 0 0 '+wcont+' 40; fill:#1D1D1B;" xml:space="preserve"><polyline class="st0" points="0,0 '+wcont/2 +',38 '+wcont+',0 "/>' +
              '<path class="st2" d="M 0,0 '+wcont/2 +',38 '+wcont+',0 " stroke-width="1" stroke="#D1AC43"/>' +
              '</svg></span>';
            var content = $compile(template)(scope);
            element.replaceWith(content);
          }, 10);
        }
      };
    })

})();

(function () {
  'use strict';
  angular
    .module('frontendApp')
    .directive('bigslide', function ($rootScope, $timeout) {
      return {
        restrict: 'A',
        scope:{
          items:'=',
          alldata:'=',
        },
        rootScope: $rootScope,
        link: function (scope, element, rootScope) {
          scope.itemSize = 120;
          $(window).resize(function () {
          }).resize();
        },
        controller:function($scope, $rootScope, $timeout, $window){
          $(window).resize(function () {
            console.log('bigslide');
          }).resize();
        }
      };
    })
})();

'use strict';
angular
  .module('frontendApp')
  .controller('SuppliersController', function ($log, TablesService, $timeout) {
    var vm = this;
    $log.debug('SuppliersController');
  })
  .controller('TraceabilityController', function ($log, TablesService, $timeout) {
    var vm = this;
    $log.debug('TraceabilityController');
  });

'use strict';
angular
  .module('frontendApp')
  .controller('ServicesController', function ($log,$state,$window,  $stateParams, TablesService, $timeout, $scope, $rootScope) {
    var vm = this;
    console.log('ServicesController');
    vm.filters2 = {
      per_page: 100,
      page: 1
    };
    TablesService.filtrar('servicio', vm.filters2)
      .success(function (res) {
        if(res.resultado) {
          console.log(res);
          vm.services = res.resultado.data;
        }
      });


  });

'use strict';
angular
  .module('frontendApp')
  .controller('RoomalbumController', function ($log,$state,$window,  $stateParams, TablesService, $timeout, $scope, $rootScope) {
    var vm = this;
    console.log('RoomalbumController');
    $rootScope.ready=true;
    vm.filters = {
      per_page: 100,
      page: 1
    };
    $rootScope.properties= {
      items: 1,
      nav:true,
      startPosition:1,
      loop:true,
      autoplay:true,
      navText : ['<span class="arrow arrow-right" ></span>','<span class="arrow arrow-right" ></span>'],
    };
    TablesService.filtrar('homeslides', vm.filters)
      .success(function (res) {
        if(res.resultado){
          vm.items = res.resultado.data;
          console.log('tems, ',vm.items)
          vm.properties= {
            items: 1,
            nav:true,
            startPosition:0,
            loop:true,
            autoplay:true,
            navigation : true,
            singleItem : true,
            animateIn: 'fadeIn', // add this
            animateOut: 'fadeOut', // and this
            autoplayTimeout:7000,
            autoplaySpeed:2000,
            navText : ['<span class="arrow arrow-right" ></span>','<span class="arrow arrow-right" ></span>'],
          };
        }
      });
    vm.ready = function ($api) {
      var owlAPi = $api;
    };



  });

'use strict';
angular
  .module('frontendApp')
  .controller('RoomController', function ($log,$state,$window,  $stateParams, TablesService, $timeout, $scope, $rootScope) {
    var vm = this;
    console.log('RoomController');
    $rootScope.ready=true;
    vm.filters = {
      per_page: 100,
      page: 1
    };
    TablesService.filtrar('homeslides', vm.filters)
      .success(function (res) {
        if(res.resultado){
          vm.rooms = res.resultado.data;
          console.log(vm.rooms)
        }
      });


    vm.filters2 = {
      per_page: 100,
      page: 1
    };
    TablesService.filtrar('servicio', vm.filters2)
      .success(function (res) {
        if(res.resultado) {
          console.log(res);
          vm.services = res.resultado.data;
        }
      });


  });

'use strict';
angular
  .module('frontendApp')
  .controller('RestController', function ($log,$state,$window,  $stateParams, TablesService, $timeout, $scope, $rootScope) {
    var vm = this;
    console.log('RestController');
    $rootScope.ready=true;
    vm.filters = {
      per_page: 100,
      page: 1
    };
    $rootScope.properties= {
      items: 1,
      nav:true,
      startPosition:1,
      loop:true,
      navText : ['<span class="arrow arrow-right" ></span>','<span class="arrow arrow-right" ></span>'],
    };
    TablesService.filtrar('homeslides', vm.filters)
      .success(function (res) {
        if(res.resultado){
          vm.items = res.resultado.data;
          console.log(vm.items)
        }
      });

    TablesService.filtrar('promocion', vm.filters)
      .success(function (res) {
        if(res.resultado){
          console.log('promociones', res);
          vm.promotions = res.resultado.data;
          vm.propertiesPromotions = {
            items: 4,
            nav:true,
            startPosition:1,
            loop:true,
            autoplay:true,
            autoplayTimeout:5000,
            responsive:{
              0:{
                items:1
              },
              767:{
                items:2
              },
              992:{
                items:2
              },
              1200:{
                items:3
              }
            },
            navText : ['<span class="arrow arrow-right" ></span>','<span class="arrow arrow-right" ></span>'],
          };
        }
      });


  });

'use strict';
angular
  .module('frontendApp')
  .controller('ProductdetailController', function ($log,$state,$window,  $stateParams, TablesService, $timeout, $scope, $rootScope) {
    var vm = this;
    var owlAPi;
    console.log('ProductdetailController');
    vm.filters = {
      per_page: 100,
      page: 1,
    };
    //$state.go('.', {parm1: 1}, {notify: false});
    vm.selected={};
    vm.selected.catalias= $stateParams.id;
    vm.selected.id= $stateParams.id2;
    vm.changeCat = function (value){
      $state.go('product', {id: value});
      vm.loadCategories ();
    };
    vm.changeProd = function (value){
      console.log('cambia producto', value)
      vm.selected.id = value.alias;
      vm.selected.prod = value.nombre;
      $state.go('product2', {id: vm.selected.catalias, id2:value.alias}, {notify: false});
    };
    vm.loadCategories = function (){
      TablesService.filtrar('productoscategorias', vm.filters)
        .success(function (res) {
          if(res.resultado){
            vm.productscat = res.resultado.data;
            for(var i = 0; i < vm.productscat.length;i++){
              if (vm.selected.catalias == vm.productscat[i].alias){
                vm.selected.cat = vm.productscat[i].id;
              }
            }
            vm.filters2 = {
              per_page: 1000,
              page: 1,
              comparaciones: [
                {
                  campo: 'productoscategorias_id',
                  operador: 'igual',
                  dato: vm.selected.cat,
                  dato2: ''
                }
              ]
            };
            console.log( vm.selected,vm.productscat )
            vm.loadProducts(vm.filters2);
          }
        });
    }
    vm.print = function(value){
      console.log("XXXXXXXXXXX",value);
      vm.changeProd(item) ;
    };
    vm.loadCategories ();
    vm.loadProducts = function(filters){
      TablesService.filtrar('productos', filters)
        .success(function (res) {
          console.log(res)
          if(res.resultado){
            vm.products = res.resultado.data;
            console.log('productos',vm.selected.id,  vm.products);

            //vm.changeProd(vm.products[0]);
            // vm.selected.id = vm.products[0].alias;
            // vm.selected.prod = vm.products[0].nombre;
            //$state.go('product2', {id: vm.selected.catalias, id2:vm.selected.id }, {notify: false});
            //console.log('id cargado', vm.selected.id);
            vm.itemIndex = 0;
            vm.properties = {
              items: 1,
              nav:true,
              startPosition:vm.itemIndex,
              onChange: function (e) {
                //console.log('//////////////////////////////')
                /*console.log("current: ", e.relatedTarget.current())
                console.log("current: ", e.item.index) //same
                console.log("total: ", e.item.count)   //total
                console.log('ejecuta cambio', e.item.index)*/
                console.log('element   ', e.target)       // DOM element, in this example .owl-carousel
                console.log('name      ', e.type)         // Name of the event, in this example dragged
                console.log('namespace ', e.namespace)      // Namespace of the event, in this example owl.carousel
                console.log('items     ', e.item.count)     // Number of items
                console.log('item      ', e.item.index)     // Position of the current item
                //console.log('vided by t',vigation plugin)
                console.log('pages     ', e.page.count)     // Number of pages
                console.log('page      ', e.page.index)     // Position of the current page
                console.log('size      ', e.page.size)
                console.log('size      ', e.itemElement)

                if (e.item.index != 0 ) {
                  //console.log('ingresa en restriccion', e.item.index);
                  //vm.selected.id = vm.products[e.item.index-2].id;
                  //vm.getId(e.item.index-2);
                  ///////////aca falta///////////////
                  //var item = vm.getItem(e.item.index);
                  //console.log('obtenido para cambio', item, e.item.index)
                  //vm.changeProd(item);
                }
              },
              loop:true,
              navText : ['<span class="glyphicon glyphicon-menu-left" ></span>','<span class="glyphicon glyphicon-menu-right" ></span>'],
            };
            $scope.ready = function ($api) {
              owlAPi = $api;
            };
            console.log('por defecto', vm.products[0]);
            //vm.changeProd(vm.products[0]);
            vm.selected.id = vm.products[0].alias;
            vm.selected.prod = vm.products[0].nombre;
            $state.go('product2', {id: vm.selected.catalias, id2:vm.selected.id }, {notify: false});

            console.log('por defecto');
            $timeout(function () {
              /*if(vm.selected.id){
                console.log('precargado');
                var current = vm.getItemByAlias(vm.selected.id);
                console.log('obtenido',current);
                vm.selected.id = current.alias;
                vm.selected.prod = current.nombre;
                console.log('nuevos seteados', vm.selected);
                var cindex = vm.getIndex(current.id);
                console.log('index extraido',cindex);
                //vm.changeProd(current);
                vm.changeSlide(current.id);
              }
              else{
                console.log('por defecto', vm.products[0]);
                //vm.changeProd(vm.products[0]);
                vm.selected.id = vm.products[0].alias;
                vm.selected.prod = vm.products[0].nombre;
                $state.go('product2', {id: vm.selected.catalias, id2:vm.selected.id }, {notify: false});
              }*/

            }, 2000)
          }
        });
    };

    vm.getIndex = function(value){
      for(var i =0;i<vm.products.length;i++){
        if (value === vm.products[i].id){
          return i;
        }
      }
    };
    vm.getItem = function(value){
      for(var i =0;i<vm.products.length;i++){
        if (value === i){
          return vm.products[i];
        }
      }
    };
    vm.getItemByAlias = function(value){
      vm.temp ={};
      for(var i =0;i<vm.products.length;i++){
        // console.log('no match')
        if (value == vm.products[i].alias){
          vm.temp = angular.copy(vm.products[i]);
        }
      }
      console.log('match',vm.temp);
      //vm.changeProd(vm.temp);
      return vm.temp;
    };

    vm.isFirst = function(value){
      if (vm.products[0].id == vm.selected.id){
        return true;
      }
      else{
        return false;
      }
    };
    vm.changeSlide = function(value) {
      console.log('cambia', value);
      owlAPi.trigger('to.owl.carousel',[value,2000]);
    };





  });

'use strict';
angular
  .module('frontendApp')
  .controller('HomeController', function (ImageLoader,$window,  $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('HomeController');
    $rootScope.ready=false;
    vm.loadSlides = function(){
      vm.filters = {
        per_page: 100,
        page: 1
      };
      TablesService.filtrar('homeslides', vm.filters)
        .success(function (res) {
          if(res.resultado){
            console.log(res);
            vm.slides = res.resultado.data;
            $rootScope.slider = res.resultado.data;
            vm.currentSlider( $rootScope.slider [0],0, false);
            $rootScope.currentSli = 0;
            vm.manual = false;
            /*$rootScope.ready=true;
            $timeout(countUp, 10000);*/
            var imageArray = vm.getImageArray(vm.slides, 'imagen');

            ImageLoader.loadImages(imageArray).then(function (loadedStrings) {
              vm.imageStringsList = loadedStrings;
              console.log(vm.imageStringsList);
              new WOW().init();
              vm.dataReady = true;
              $timeout(function () {
                var evt = $window.document.createEvent('UIEvents');
                evt.initUIEvent('resize', true, false, $window, 0);
                $window.dispatchEvent(evt);
                $rootScope.ready=true;
                $timeout(countUp, 10000);
              }, 5000);
            });
          }
        });
      vm.getImageArray = function (source, target) {
        var imageArray = [];
        angular.forEach(source, function (value, key) {
          if (value[target]) {
            imageArray.push(value[target]);
          }
        });
        return imageArray;
      };
      TablesService.filtrar('homegallery', vm.filters)
        .success(function (res) {
          if(res.resultado){
            console.log('gallery', res);
            vm.gallery = res.resultado.data;
            //$timeout(countUp, 7000);
            vm.propertiesGallery = {
              items: 1,
              nav:true,
              startPosition:1,
              /*onChange: function (e) {
              },*/
              loop:true,
              navigation : true,
              singleItem : true,
              animateIn: 'fadeIn', // add this
              animateOut: 'fadeOut', // and this
              autoplay:true,
              /*
              autoplay:true,
              autoplayTimeout:10000,
              autoplaySpeed:2000,
              autoplayHoverPause:true,*/
              navText : ['<span class="arrow arrow-right" ></span>','<span class="arrow arrow-right" ></span>'],
            };
          }
        });
      TablesService.filtrar('promocion', vm.filters)
        .success(function (res) {
          if(res.resultado){
            console.log('promociones', res);
            vm.promotions = res.resultado.data;
            vm.propertiesPromotions = {
              items: 4,
              nav:true,
              startPosition:1,
              loop:true,
              autoplay:true,
              autoplayTimeout:5000,
              responsive:{
                0:{
                  items:1
                },
                767:{
                  items:2
                },
                992:{
                  items:2
                },
                1200:{
                  items:3
                }
              },
              navText : ['<span class="arrow arrow-right" ></span>','<span class="arrow arrow-right" ></span>'],
            };
            owl.trigger('owl.play',6000);
          }
        });
      vm.filters2 = {
        per_page: 100,
        page: 1,
        comparaciones:[ {
          campo: 'visible',
          operador: 'igual',
          dato: 1,
          dato2: ''
        }]
      }
      TablesService.filtrar('comentarios', vm.filters2)
        .success(function (res) {
          if(res.resultado){
            console.log('comentarios', res);
            vm.comments = res.resultado.data;
            vm.propertiesComments = {
              items: 5,
              nav:true,
              startPosition:1,
              loop:true,
              autoplay:true,
              autoplayTimeout:10000,
              /*autoplaySpeed:2000,
              autoplayHoverPause:true,*/
              responsive:{
                0:{
                  items:1
                },
                767:{
                  items:3
                },
                1024:{
                  items:3
                },
                1280:{
                  items:4
                }
              },
              navText : ['<span class="arrow arrow-right" ></span>','<span class="arrow arrow-right" ></span>'],
            };
          }
        });
    };
    vm.loadSlides();
    $rootScope.currentSli = 0;
    vm.currentSlider = function(value, index, manual){
      vm.currentSlide = value;
      $rootScope.currentSli = index;
      console.log('actual',vm.currentSlide);
      if(manual){
        vm.manual = true;
      }
    };
    var countUp = function () {
      console.log('ejecuta');
      if(!vm.manual){
        if ($rootScope.currentSli >= $rootScope.slider.length - 1) {
          $rootScope.currentSli = 0;
        }
        else {
          $rootScope.currentSli += 1;
        }
        vm.currentSlider( $rootScope.slider[$rootScope.currentSli],$rootScope.currentSli);
      }
      else{
        vm.manual = false;
      }
      $timeout(countUp, 10000);
    };
    $rootScope.pickItem = function (value) {
      var limit =  $rootScope.slider.length - 1;

      if(!vm.manual ){
        switch (value) {
          case 'prev':
            ($rootScope.currentSli > 0) ? $rootScope.currentSli-- : $rootScope.currentSli = limit;
            console.log(1);
            break;
          case 'next':
            ($rootScope.currentSli < limit) ? $rootScope.currentSli++ : $rootScope.currentSli = 0;
            console.log(2);
            break;
          default:
            $rootScope.currentSli = value;
            break;
        }
      }
      vm.manual = true;
      $timeout(function () {
        vm.manual = false;
      }, 3000);
      vm.currentSlider( $rootScope.slider[$rootScope.currentSli],$rootScope.currentSli, true);
    };

    vm.print =function(value){
      console.log(value)
    };

    vm.options = {
      //customClass: getDayClass,
      minDate: new Date(),
      showWeeks: false
    };

    vm.dp1 = false;
    vm.dp2 = false;

    vm.reserve = {};
    vm.reserve.guests = 0;

    vm.setGuests = function (value){
      if (value == 'minus' && vm.reserve.guests >0){
        vm.reserve.guests--;
      }
      else{
        vm.reserve.guests++;
      }
    };

    vm.goReserve = function (value){
      console.log('envia reserva', vm.reserve)
    };


    vm.ready = function ($api) {
      var owlAPi = $api;
    };




    vm.sendMail = function(emailId,subject,message){
      $window.open("mailto:"+ emailId + "?subject=" + subject+"&body="+message,"_self");
    };
  });

'use strict';
angular
  .module('frontendApp')
  .controller('ContactController', function ($log, $rootScope, $timeout, $window, TablesService) {
    var vm = this;
    $log.debug('ContactController');
    //CAPTCHA

    vm.screenWidth = $window.innerWidth;
    $log.debug('screenWidth', vm.screenWidth);

    vm.gencaptcha = function(){
      angular.element(document).ready(function () {
        jQuery.ajax({
          url: 'https://www.google.com/recaptcha/api.js?hl=es',
          dataType: 'script',
          async: true,
          deferer: true
        });
      });
    };

    $rootScope.accordion = [
        false, false, false, false, false, false
    ];

    //Combo business
    vm.catSelect = function(b){
      vm.businessSel = b;
    };
    vm.catBusiness = [
      {
        id: 1,
        nombre: 'Wholesaler'
      },{
        id: 2,
        nombre: 'Retailer'
      },{
        id: 3,
        nombre: 'Detailed Chain'
      },{
        id: 4,
        nombre: 'Supermarket'
      },{
        id: 5,
        nombre: 'Hypermarket'
      },{
        id: 6,
        nombre: 'Department Store'
      },{
        id: 7,
        nombre: 'Broker'
      }
    ];
    vm.categories = [
      {id: 1, name: "Production and Processing Facilities"},
      {id: 2, name: "Own Offices"},
      {id: 3, name: "Trading"},
      {id: 4, name: "We take our products to"}
    ];

    vm.countriesAll = [
      {iso: "BOL", name: "Bolivia", category: "1"},
      {iso: "PER", name: "Perú", category: "2"},
      {iso: "COL", name: "Colombia", category: "2"},
      {iso: "CRI", name: "Costa Rica", category: "2"},
      {iso: "CHI", name: "Chile", category: "3"},
      {iso: "MYS", name: "Malaysia", category: "3"},
      {iso: "TWN", name: "Taiwan", category: "3"},
      {iso: "HKG", name: "Hong Kong", category: "3"},
      {iso: "AUS", name: "Australia", category: "3"},
      {iso: "RUS", name: "Russia", category: "3"},
      {iso: "ARE", name: "United Arab Emirates", category: "4"},
      {iso: "FRA", name: "France", category: "4"},
      {iso: "GBR", name: "England", category: "4"},
      {iso: "SGP", name: "Singapore", category: "4"},
      {iso: "CAN", name: "Canada", category: "4"},
      {iso: "DNK", name: "Denmark", category: "4"},
      {iso: "ARG", name: "Argentina", category: "4"},
      {iso: "BRA", name: "Brazil", category: "4"},
      {iso: "ESP", name: "Spain", category: "4"},
      {iso: "GER", name: "Germany", category: "4"},
      {iso: "ISR", name: "Israel", category: "4"}
    ];

    $rootScope.findCountryByIso = function (iso) {
      return vm.countriesAll.filter(function (country) {
        return country.iso === iso;
      });
    };

    $rootScope.findCategories = function (cid) {
      return vm.categories.filter(function (country) {
        return parseInt(country.id) === parseInt(cid);
      });
    };

    $rootScope.colors = function (cid) {
      switch (cid) {
        case "1":
          return '#B43D32';
        case "2":
          return '#E8443A';
        case "3":
          return '#F18952';
        case "4":
          return '#FAB84E';
      }
    };

    vm.generarSeguridad = function () {
      vm.company = '';
      vm.businessSel = null;
      vm.name = '';
      vm.country = '';
      vm.city = '';
      vm.phone = '';
      vm.email = '';
      vm.subject = '';
      vm.message = '';
      grecaptcha.reset();
    };
    vm.enviarContacto = function(){
      vm.enviando = true;
      if(!vm.company){ vm.company = ''; }
      if(!vm.businessSel){ vm.businessSel = {nombre: ''}; }
      if(!vm.phone){ vm.phone = ''; }
      var datosenviar = {
        empresa: vm.company,
        sector: vm.businessSel.nombre,
        nombre: vm.name,
        cargo: '',
        pais: vm.country,
        ciudad: vm.city,
        telefono: vm.phone,
        email: vm.email,
        motivo: vm.subject,
        mensaje: vm.message,
        gc: jQuery('#g-recaptcha-response').val()
      };
      TablesService.contactar(datosenviar)
        .then(function (res) {
          $log.debug(res);
          vm.enviando = false;
          if (res.data.respuesta) {
            vm.msjtrue = true;
            vm.mensajeForm = 'Thank you! Your message is travelling all the way to Bolivia, we will contact you soon!';
            vm.generarSeguridad();
            $timeout(function () {
              vm.msjtrue = false;
              vm.mensajeForm = '';
            }, 4000);
          } else {
            vm.generarSeguridad();
          }
        })
        .catch(function (response) {
          vm.enviando = false;
          switch (response.data.error) {
            case 'is_robot':
              $log.debug('Intento de conexión forzado.');
              vm.mensajeForm = 'Attempt of forced connection';
              break;
            case 'not_security_validation':
              $log.debug('Verifique que no es un robot.');
              vm.mensajeForm = 'Verify that it is not a robot';
              break;
            default : vm.mensajeForm = 'Error sending try again please';
          }
          vm.generarSeguridad();
        });
    };

    /*var mensaje = {
      empresa: 'empresa',
      sector: 'sector',
      nombre: 'nombre',
      cargo: 'cargo',
      pais: 'pais',
      ciudad: 'ciudad',
      telefono: 'telefono',
      email: 'email',
      motivo: 'motivo',
      mensaje: 'mensaje'
    };
    TablesService.contactar(mensaje).success(function (res) {
      console.log(res);
    });*/

  });


'use strict';
angular
  .module('frontendApp')
  .controller('AppController', function ($log, TablesService) {
    var vm = this;
    $log.debug('AppController');

    /*//LISTAR
    TablesService.listar('tour').success(function (res) {
      $log.debug('Tours: ', res);
    });

    //FILTRAR
    var params = {
      //Número de página
      page: 1,
      //Cantidad de registros por página
      per_page: 1,
      //Comparacion de campos
      comparaciones: [
        {campo: 'activo', operador: 'igual', dato: 1}
      ],
      //Orden de registros (asc|desc)
      orden: [
        {campo: 'id', direccion: 'desc'}
      ]
    };
    TablesService.filtrar('tour', params).success(function (res) {
      $log.debug('Tour filtrados: ', res);
    });*/

  })
  .controller('CertificationsController', function ($log, TablesService) {
    var vm = this;
    $log.debug('CertificationsController');

    var params = {
      page: 1,
      per_page: 999,
      orden: [
        {campo: 'orden', direccion: 'asc'}
      ]
    };
    TablesService.filtrar('certificaciones', params).success(function (res) {
      $log.debug('Certifications: ', res);
      vm.certifications = res.resultado.data;
    });
    /*TablesService.listar('certificaciones').success(function (res) {
      $log.debug('Certifications: ', res);
      vm.certifications = res.resultado;
    });*/

  });

(function() {
  'use strict';

  angular
      .module('frontendApp')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1516719002839;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, localStorageService, $timeout, $window) {
    //$rootScope.api = 'http://avc.indomita.bo/restapi';
    //$rootScope.api = 'http://localhost:8000';
    $rootScope.api = 'http://mitrusur.com/api';
    //$rootScope.api = 'http://192.168.0.24:8000';
    $rootScope.switchText=function(value1, value2){
      if($rootScope.language=='es'){
        return value1;
      }
      else{
        return value2;
      }
    };
    $rootScope.language = 'en';


    $rootScope.obtenerVarSession = function (key) {
      return localStorageService.get(key);
    };
    $rootScope.asignarVarSession = function (key, val) {
      return localStorageService.set(key, val);
    };
    $rootScope.changeLanguage = function (value, state) {
      $rootScope.language = value;
      $rootScope.asignarVarSession('language', value);
      $state.go(state, {lan: value});
    };

    var stateActual = function(){
      $rootScope.actualstate = $state.current.name;
      $log.debug($rootScope.actualstate);
    };
    stateActual();
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      $("html, body").animate({scrollTop: 0}, 1000);
      $state.current = toState;
      $rootScope.$state = $state;
      $rootScope.currentState = $state.current.name;
      console.log( 'actual',  $rootScope.currentState)
      var x = $rootScope.obtenerVarSession('language');
      (x) ? $rootScope.language = x : $rootScope.language = 'es';
    });

    $rootScope.backTop = function (){
      $("html, body").animate({ scrollTop: 0}, 1000);
    };

    $log.debug('intenet explerer navigator', window.navigator.userAgent);
    if(navigator.userAgent.indexOf("MSIE") != -1){
      $log.debug('intenet explerer navigator', window.navigator.userAgent);
    }

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      /*.state('home', {
        url: '/',
        templateUrl: 'app/views/home.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })*/
      .state('home', {
        url: '/:lan',
        templateUrl: 'app/views/home2.html',
        controller:'HomeController',
        controllerAs: 'home'
      })
      .state('rooms', {
        url: '/:lan/rooms',
        templateUrl: 'app/views/rooms/roomshome.html',
        controller:'RoomController',
        controllerAs: 'rooms'
      })
      .state('roomalbum', {
        url: '/:lan/roomalbum',
        templateUrl: 'app/views/rooms/room.html',
        controller:'RoomalbumController',
        controllerAs: 'room'
      })
      .state('spaces', {
        url: '/:lan/spaces',
        templateUrl: 'app/views/spaces/spaceshome.html',
        controller:'RoomController',
        controllerAs: 'spaces'
      })
      .state('spacealbum', {
        url: '/:lan/spacealbum',
        templateUrl: 'app/views/spaces/space.html',
        controller:'RoomalbumController',
        controllerAs: 'space'
      })
      .state('restaurant', {
        url: '/:lan/restaurant',
        templateUrl: 'app/views/culinary/restaurant.html',
        controller:'RestController',
        controllerAs: 'rest'
      })
      .state('service', {
        url: '/:lan/service',
        templateUrl: 'app/views/rooms/services.html',
      })
      .state('bar', {
        url: '/:lan/bar',
        templateUrl: 'app/views/culinary/bar.html',
        controller:'RestController',
        controllerAs: 'bar'
      })
      .state('promotions', {
        url: '/:lan/promotions',
        templateUrl: 'app/views/promotions/promotions.html',
        controller:'RestController',
        controllerAs: 'promo'
      })
      .state('history', {
        url: '/:lan/history',
        templateUrl: 'app/views/history/history.html',
        controller:'RestController',
        controllerAs: 'hist'
      })
      .state('contact', {
        url: '/:lan/contact',
        templateUrl: 'app/views/contact/contact.html',
        controller:'RestController',
        controllerAs: 'contact'
      })
      .state('loader', {
        url: '/:lan/loader',
        templateUrl: 'app/views/loader.html',
      })
    ;

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('frontendApp')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('frontendApp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $locationProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    $locationProvider.html5Mode(true).hashPrefix('#');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
    new WOW().init();
  }

})();

angular.module("frontendApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"container\"><div><acme-navbar creation-date=\"main.creationDate\"></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=\"lead\"><img src=\"assets/images/yeoman.png\" alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=\"main.classAnimation\"><button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\"><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{awesomeThing.url}}\">{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/views/footer.html","<div class=\"container-fluid\" data-ng-if=\"ready\"><div class=\"back-top\" data-ng-click=\"backTop()\"></div><div class=\"footer\"><div class=\"box\"></div><div class=\"box\"><p>©2018 MitruSur • Todos los derechos reservados</p></div><div class=\"box\"><div class=\"social instagram\"></div><div class=\"social twitter\"></div><div class=\"social facebook\"></div></div></div></div>");
$templateCache.put("app/views/header.html","<div class=\"container-fluid\" data-ng-if=\"ready\"><div class=\"header row\"><div class=\"navbar navbar-default\" role=\"navigation\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" ng-init=\"navCollapsed = true\" ng-click=\"navCollapsed = !navCollapsed\" data-toggle=\"collapse\" data-target=\"#js-navbar-collapse\"><span class=\"icon-arrow-down\"></span> <span class=\"icon-arrow-up\"></span></button> <a class=\"navbar-brand logo\" ui-sref=\"home({lan: language})\" href=\"\"></a></div><div class=\"collapse navbar-collapse\" id=\"js-navbar-collapse\" collapse=\"navCollapsed\"><ul class=\"nav navbar-nav navbar-right\"><li class=\"lan\" data-ng-class=\"{\'active\':currentState==\'contact\'}\"><div class=\"lans\"><a data-ng-class=\"{\'active\':language==\'es\'}\" class=\"es\" data-ng-click=\"changeLanguage(\'es\',$state.current.name)\">ES</a> <strong>/</strong> <a data-ng-class=\"{\'active\':language==\'en\'}\" class=\"en\" data-ng-click=\"changeLanguage(\'en\',$state.current.name)\">EN</a></div><button data-ng-bind-html=\"switchText(\'RESERVAR\',\'RESERVE\')\" href=\"\" class=\"btn btn-theme\"></button></li></ul><ul class=\"nav navbar-nav navbar-right principal\"><li data-ng-class=\"{\'active\':currentState==\'home\'|| currentState==\'home2\'}\"><a ui-sref=\"home2({lan: language})\" data-ng-bind-html=\"switchText(\'Inicio\',\'Home\')\"></a></li><li data-ng-class=\"{\'active\':currentState==\'rooms\'}\"><a ui-sref=\"rooms({lan: language})\" data-ng-bind-html=\"switchText(\'habitaciones\',\'rooms\')\"></a></li><li class=\"\" data-ng-class=\"{\'active\':currentState==\'restaurant\', \'dropdown2\':submenu}\"><a ng-init=\"submenu = false\" ng-mouseover=\"submenu = true\" ng-mouseleave=\"submenu = false\">{{switchText(\'PLACERES CULINARIOS\',\'CULINARY PLEASURES\')}}<div class=\"logos\" data-ng-show=\"submenu\" ng-mouseover=\"submenu = true\" ng-init=\"draw2 = false\" ng-mouseleave=\"submenu = false\"><img data-wow-delay=\"1s\" class=\"wow fadeIn l1\" ui-sref=\"restaurant({lan: language})\" src=\"assets/images/logos/lujoso_blanco.svg\" alt=\"\"><div class=\"tline2\" data-ng-class=\"{ draw2: submenu }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 16 60\" style=\"enable-background:new 0 0 16 220;\" xml:space=\"preserve\"><style type=\"text/css\">\n                      .st0{fill:none;stroke:#D1AC43;}\n                    </style><line class=\"st0\" x1=\"8\" y1=\"8\" x2=\"8\" y2=\"60\"></line></svg></div><img data-wow-delay=\"1s\" class=\"wow fadeIn l2\" ui-sref=\"bar({lan: language})\" src=\"assets/images/logos/sky_blanco.svg\" alt=\"\"></div></a></li><li data-ng-class=\"{\'active\':(currentState==\'spaces\'||currentState==\'spacealbum\')}\"><a ui-sref=\"spaces({lan: language})\" data-ng-bind-html=\"switchText(\'ESPACIOS\',\'SPACES\')\"></a></li><li class=\"dropdown\" data-ng-class=\"{\'active\':(currentState==\'promotions\') }\"><a class=\"dropbtn\" ui-sref=\"promotions({lan: language})\" data-ng-bind-html=\"switchText(\'PROMOCIONES\',\'PROMOTIONS\')\"></a></li><li class=\"dropdown\" data-ng-class=\"{\'active\':(currentState==\'history\') }\"><a class=\"dropbtn\" ui-sref=\"history({lan: language})\" data-ng-bind-html=\"switchText(\'HISTORIA\',\'HISTORY\')\"></a></li><li class=\"dropdown\" data-ng-class=\"{\'active\':(currentState==\'contact\') }\"><a class=\"dropbtn\" ui-sref=\"contact({lan: language})\" data-ng-bind-html=\"switchText(\'CONTACTO\',\'CONTACT\')\"></a></li></ul></div></div><div class=\"gift\" ui-sref=\"promotions({lan: language})\"></div></div><div class=\"menu-resp row\" data-ng-class=\"{\'open\':menuresp}\"><div class=\"top-menu\"><a class=\"navbar-brand logo\" ui-sref=\"home({lan: language})\" href=\"\"></a> <button data-ng-bind-html=\"switchText(\'RESERVAR\',\'RESERVE\')\" href=\"\" class=\"btn btn-theme\"></button> <a class=\"btn btn-default burger\" data-ng-class=\"{\'open\':menuresp}\" ng-init=\"menuresp = false\" data-ng-click=\"menuresp = !menuresp\" href=\"\"></a></div><div class=\"bottom-menu\" data-ng-if=\"menuresp\"><ul class=\"menu\"><li data-ng-class=\"{\'active\':currentState==\'home\'|| currentState==\'home2\'}\"><a ui-sref=\"home2({lan: language})\" data-ng-bind-html=\"switchText(\'Inicio\',\'Home\')\"></a></li><li data-ng-class=\"{\'active\':currentState==\'rooms\'}\"><a ui-sref=\"rooms({lan: language})\" data-ng-bind-html=\"switchText(\'habitaciones\',\'rooms\')\"></a></li><li class=\"esp\" data-ng-class=\"{\'active\':currentState==\'restaurant\'}\"><a ui-sref=\"restaurant({lan: language})\" data-ng-bind-html=\"switchText(\'PLACERES CULINARIOS\',\'CULINARY PLEASURES\')\"></a></li><li data-ng-class=\"{\'active\':(currentState==\'spaces\'||currentState==\'spacealbum\')}\"><a ui-sref=\"spaces({lan: language})\" data-ng-bind-html=\"switchText(\'ESPACIOS\',\'SPACES\')\"></a></li><li class=\"dropdown\" data-ng-class=\"{\'active\':(currentState==\'promotions\') }\"><a class=\"dropbtn\" ui-sref=\"promotions({lan: language})\" data-ng-bind-html=\"switchText(\'PROMOCIONES\',\'PROMOTIONS\')\"></a></li><li class=\"dropdown\" data-ng-class=\"{\'active\':(currentState==\'history\') }\"><a class=\"dropbtn\" ui-sref=\"history({lan: language})\" data-ng-bind-html=\"switchText(\'HISTORIA\',\'HISTORY\')\"></a></li><li class=\"dropdown\" data-ng-class=\"{\'active\':(currentState==\'contact\') }\"><a class=\"dropbtn\" ui-sref=\"contact({lan: language})\" data-ng-bind-html=\"switchText(\'CONTACTO\',\'CONTACT\')\"></a></li><li class=\"lan\" data-ng-class=\"{\'active\':currentState==\'contact\'}\"><div class=\"lans\"><a data-ng-class=\"{\'active\':language==\'es\'}\" class=\"es\" data-ng-click=\"changeLanguage(\'es\',$state.current.name)\">ES</a> <strong>/</strong> <a data-ng-class=\"{\'active\':language==\'en\'}\" class=\"en\" data-ng-click=\"changeLanguage(\'en\',$state.current.name)\">EN</a></div></li></ul></div></div></div>");
$templateCache.put("app/views/home.html","<div class=\"container-fluid\"><div class=\"home-cons loader\"><div windowheight=\"\" class=\"left\"><div class=\"box wow fadeIn\" data-wow-duration=\"2s\"><div class=\"mask mask-2\"><div class=\"glass\"></div></div></div><small>Sitio en construcción</small><div class=\"text wow fadeIn\"><p>+591 - 77277051 /+591 - 2 2790765 / +591 - 2 2916969</p><p>reservas@mitrusur.com</p><p>info@mitrusur.com</p><p>Av. Fuerza naval 948 - Calacoto</p></div><div class=\"text border\"><strong>LA PAZ - BOLIVIA</strong></div></div><div windowheight=\"\" class=\"right\"><ng-map windowheight=\"\" center=\"-16.536606, -68.075885\" zoom=\"17\" styles=\'[{ \"featureType\": \"administrative\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": \"-100\"}] }, { \"featureType\": \"administrative.province\", \"elementType\": \"all\", \"stylers\": [{\"visibility\": \"off\"}] }, { \"featureType\": \"landscape\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": -100}, {\"lightness\": 65}, {\"visibility\": \"on\"}] }, { \"featureType\": \"poi\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": -100}, {\"lightness\": \"20\"}, {\"visibility\": \"simplified\"}] }, {\"featureType\": \"road\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": \"-100\"}]}, { \"featureType\": \"road.highway\", \"elementType\": \"all\", \"stylers\": [{\"visibility\": \"simplified\"}] }, { \"featureType\": \"road.arterial\", \"elementType\": \"all\", \"stylers\": [{\"lightness\": \"30\"}] }, {\"featureType\": \"road.local\", \"elementType\": \"all\", \"stylers\": [{\"lightness\": \"40\"}]}, { \"featureType\": \"transit\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": -100}, {\"visibility\": \"simplified\"}] }, { \"featureType\": \"water\", \"elementType\": \"geometry\", \"stylers\": [{\"hue\": \"#ffff00\"}, {\"lightness\": -25}, {\"saturation\": -97}] }, {\"featureType\": \"water\", \"elementType\": \"labels\", \"stylers\": [{\"lightness\": -25}, {\"saturation\": -100}]}]\'><marker position=\"-16.536744, -68.076022\" title=\"Mitru Sur\" icon=\"../assets/images/icons/marker.png\"></marker></ng-map></div></div></div>");
$templateCache.put("app/views/home2.html","<ng-include src=\"\'app/views/loader.html\'\"></ng-include><ng-include src=\"\'app/views/header.html\'\"></ng-include><div class=\"container-fluid\" data-ng-if=\"ready\" data-sr-container=\'{ \"reset\":true, \"vFactor\": 0.2 , \"mobile\": true}\'><ng-include src=\"\'app/views/home/banner.html\'\"></ng-include><ng-include src=\"\'app/views/home/gallery.html\'\"></ng-include><ng-include src=\"\'app/views/home/promotions.html\'\"></ng-include><ng-include src=\"\'app/views/home/where.html\'\"></ng-include><ng-include src=\"\'app/views/home/comments.html\'\"></ng-include></div><ng-include src=\"\'app/views/footer.html\'\"></ng-include>");
$templateCache.put("app/views/loader.html","<div class=\"container-fluid\" data-ng-if=\"!ready\"><div windowheight=\"\" class=\"loader row\"><div class=\"box\"><div class=\"mask\"><div class=\"glass\"></div></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/views/contact/contact.html","<ng-include src=\"\'app/views/header.html\'\"></ng-include><div class=\"container-fluid\"><div class=\"contact\" windowheight=\"\"><div class=\"contact-form wow fadeInUp\"><label class=\"\">NOMBRE</label> <input type=\"text\" class=\"form-control\"></div><div class=\"contact-form wow fadeInUp\"><label class=\"\">E-MAIL</label> <input type=\"text\" class=\"form-control\"></div><div class=\"contact-form wow fadeInUp\"><label class=\"\">ASUNTO</label> <input type=\"text\" class=\"form-control\"></div><div class=\"contact-form wow fadeInUp\"><label class=\"\">MENSAJE</label> <textarea name=\"\" class=\"form-control\"></textarea></div><div class=\"contact-form wow fadeInUp\" style=\"text-align: center\"><button class=\"btn btn-theme\" data-ng-bind-html=\"switchText(\'ENVIAR\',\'SEND\')\"></button></div><div class=\"map\"><div class=\"home-title\" data-in-view=\"home.htop2 = $inview\" data-ng-style=\"(home.htop2)?{\'top\': \'0\'}:{}\"><h1 class=\"htop\" data-ng-bind-html=\"switchText(\'Dónde\',\'Where\')\"></h1><h1 class=\"hbotom\" data-ng-bind-html=\"switchText(\'Encontrarnos\',\'To find us\')\"></h1></div><div sliderhome=\"\" class=\"home-map\"><ng-map sliderhome=\"\" center=\"-16.536400, -68.076022\" zoom=\"17\" styles=\'[{ \"featureType\": \"administrative\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": \"-100\"}] }, { \"featureType\": \"administrative.province\", \"elementType\": \"all\", \"stylers\": [{\"visibility\": \"off\"}] }, { \"featureType\": \"landscape\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": -100}, {\"lightness\": 65}, {\"visibility\": \"on\"}] }, { \"featureType\": \"poi\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": -100}, {\"lightness\": \"90\"}, {\"visibility\": \"off\"}] }, { \"featureType\": \"road\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": \"-100\"}]}, { \"featureType\": \"road.highway\", \"elementType\": \"all\", \"stylers\": [{\"visibility\": \"simplified\"}] }, { \"featureType\": \"road.arterial\", \"elementType\": \"all\", \"stylers\": [{\"lightness\": \"30\"}] }, { \"featureType\": \"road.local\", \"elementType\": \"all\", \"stylers\": [{\"lightness\": \"40\"}]}, { \"featureType\": \"transit\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": -100}, {\"visibility\": \"simplified\"}] }, { \"featureType\": \"water\", \"elementType\": \"geometry\", \"stylers\": [{\"hue\": \"#ffff00\"}, {\"lightness\": -25}, {\"saturation\": -97}] }, { \"featureType\": \"water\", \"elementType\": \"labels\", \"stylers\": [{\"lightness\": -25}, {\"saturation\": -100}]}]\'><marker position=\"-16.536744, -68.076022\" title=\"Mitru Sur\" icon=\"../assets/images/icons/marker.png\"></marker></ng-map></div></div><div class=\"contact-info wow fadeInUp\"><p>+591 - 77277051 /+591 - 2 2790765 / +591 - 2 2916969<br>reservas@mitrusur.com<br>info@mitrusur.com<br>Av. Fuerza Naval 948 - Calacoto<br>LA PAZ • BOLIVIA</p></div></div></div><ng-include src=\"\'app/views/footer.html\'\"></ng-include>");
$templateCache.put("app/views/culinary/bar.html","<ng-include src=\"\'app/views/header.html\'\"></ng-include><div class=\"container-fluid\"><div class=\"roomalbum\" windowheight=\"\"><ng-owl-carousel windowheight=\"\" class=\"owl-theme sliderhome\" owl-items=\"bar.items\" owl-properties=\"properties\" owl-ready=\"bar.ready($api)\"><div class=\"item catprod\" windowheight=\"\" data-ng-repeat=\"item in bar.items\"><div class=\"img-gallery\" windowheight=\"\" data-ng-style=\"{\'background\': \'url(\' + item.imagen + \')\'}\"><img class=\"logores wow fadeIn\" src=\"assets/images/logos/sky_blanco.svg\" alt=\"\"></div></div></ng-owl-carousel><div class=\"social instagram\"></div><div class=\"social twitter\"></div><div class=\"social facebook\"></div></div><div class=\"restaurant\"><div class=\"rest-brand left\"><img src=\"../assets/images/logos/sky_blanco.svg\" alt=\"\"></div><div class=\"rest-title left\"><h4 class=\"title\">Lorem ipsum dolor.</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi excepturi facere nulla quae quibusdam tempora!</p><div class=\"line2\" data-in-view=\"bar.tit2 = $inview\" data-ng-class=\"{ draw: bar.tit2 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 16 220\" style=\"enable-background:new 0 0 16 220;\" xml:space=\"preserve\"><style type=\"text/css\">\n            .st0{fill:none;stroke:#D1AC43;}\n          </style><line class=\"st0\" x1=\"8\" y1=\"8\" x2=\"8\" y2=\"220\"></line></svg></div></div><div class=\"rest-subt right\"><h2>BEBIDAS</h2><div class=\"line\" data-in-view=\"bar.tit1 = $inview\" data-ng-class=\"{ draw: bar.tit1 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 200 6\" style=\"enable-background:new 0 0 200 6;\" xml:space=\"preserve\"><style type=\"text/css\">\n               .st0 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n          </style><g><line class=\"st0\" x1=\"200\" y1=\"3\" x2=\"0\" y2=\"3\"></line></g></svg></div></div><div class=\"promotions\" data-ng-if=\"bar.promotions\"><ng-owl-carousel class=\"owl-theme\" owl-items=\"bar.promotions\" owl-properties=\"bar.propertiesPromotions\" owl-ready=\"bar.ready($api)\"><div class=\"item catprod\" bottom-height=\"\" data-ng-repeat=\"item in bar.promotions\"><div class=\"img\" bottom-height-2=\"\" background=\"{{item.imagen_small}}\"></div><h4 data-ng-bind-html=\"item.titulo\"></h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consectetur dolorum ea provident recusandae reiciendis voluptas.</p></div></ng-owl-carousel></div><div class=\"rest-subt left\"><div class=\"line\" data-in-view=\"bar.tit3 = $inview\" data-ng-class=\"{ draw: bar.tit3 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 200 6\" style=\"enable-background:new 0 0 200 6;\" xml:space=\"preserve\"><style type=\"text/css\">\n               .st0 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n          </style><g><line class=\"st0\" x1=\"0\" y1=\"3\" x2=\"200\" y2=\"3\"></line></g></svg></div><h2>BOCADILLOS</h2></div><div class=\"promotions\" data-ng-if=\"bar.promotions\"><ng-owl-carousel class=\"owl-theme\" owl-items=\"bar.promotions\" owl-properties=\"bar.propertiesPromotions\" owl-ready=\"bar.ready($api)\"><div class=\"item catprod\" bottom-height=\"\" data-ng-repeat=\"item in bar.promotions\"><div class=\"img\" bottom-height-2=\"\" background=\"{{item.imagen_small}}\"></div><h4 data-ng-bind-html=\"item.titulo\"></h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consectetur dolorum ea provident recusandae reiciendis voluptas.</p></div></ng-owl-carousel></div></div></div><ng-include src=\"\'app/views/footer.html\'\"></ng-include>");
$templateCache.put("app/views/culinary/restaurant.html","<ng-include src=\"\'app/views/header.html\'\"></ng-include><div class=\"container-fluid\"><div class=\"roomalbum\" windowheight=\"\"><ng-owl-carousel windowheight=\"\" class=\"owl-theme sliderhome\" owl-items=\"rest.items\" owl-properties=\"properties\" owl-ready=\"rest.ready($api)\"><div class=\"item catprod\" windowheight=\"\" data-ng-repeat=\"item in rest.items\"><div class=\"img-gallery\" windowheight=\"\" data-ng-style=\"{\'background\': \'url(\' + item.imagen + \')\'}\"><h5>{{item.nombre}}</h5><img class=\"logores wow fadeIn\" src=\"assets/images/logos/lujoso_blanco.svg\" alt=\"\"></div></div></ng-owl-carousel><div class=\"social instagram\"></div><div class=\"social twitter\"></div><div class=\"social facebook\"></div></div><div class=\"restaurant\"><div class=\"rest-title\"><h4 class=\"title\">Lorem ipsum dolor.</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi excepturi facere nulla quae quibusdam tempora!</p><div class=\"line2\" data-in-view=\"rest.tit2 = $inview\" data-ng-class=\"{ draw: rest.tit2 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 16 220\" style=\"enable-background:new 0 0 16 220;\" xml:space=\"preserve\"><style type=\"text/css\">\n            .st0{fill:none;stroke:#D1AC43;}\n          </style><line class=\"st0\" x1=\"8\" y1=\"8\" x2=\"8\" y2=\"220\"></line></svg></div></div><div class=\"rest-brand\"><img src=\"../assets/images/logos/lujoso_blanco.svg\" alt=\"\"></div><div class=\"rest-subt right\"><h2>ENTRADAS</h2><div class=\"line\" data-in-view=\"rest.tit1 = $inview\" data-ng-class=\"{ draw: rest.tit1 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 200 6\" style=\"enable-background:new 0 0 200 6;\" xml:space=\"preserve\"><style type=\"text/css\">\n               .st0 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n          </style><g><line class=\"st0\" x1=\"200\" y1=\"3\" x2=\"0\" y2=\"3\"></line></g></svg></div></div><div class=\"rest-item wow\" data-wow-duration=\"1s\" data-ng-class=\"{\'type2\' : ( $index % 2 == 1), \'fadeInRight\':($index % 2 == 1),\'fadeInLeft\':($index % 2 == 0)}\" data-ng-repeat=\"item in rest.items\"><div class=\"box-image\" data-in-view=\"rest[$index] = $inview\" data-ng-class=\"{ booktype: rest[$index]}\" data-ng-style=\"{\'background\': \'url(\' + item.imagen + \')\'}\"></div><div class=\"box-text\"><h4>ensalada</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deleniti error exercitationem magni mollitia quas, quasi suscipit tempore temporibus ut voluptatem.</p><div class=\"iconf\"><span class=\"icon-food\"></span> <span class=\"icon-food\"></span></div></div></div><div class=\"rest-subt left\"><div class=\"line\" data-in-view=\"rest.tit1 = $inview\" data-ng-class=\"{ draw: rest.tit1 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 200 6\" style=\"enable-background:new 0 0 200 6;\" xml:space=\"preserve\"><style type=\"text/css\">\n               .st0 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n          </style><g><line class=\"st0\" x1=\"0\" y1=\"3\" x2=\"200\" y2=\"3\"></line></g></svg></div><h2>ALMUERZO</h2></div><div class=\"rest-item wow\" data-wow-duration=\"1s\" data-ng-class=\"{\'type2\' : ( $index % 2 == 1), \'fadeInRight\':($index % 2 == 1),\'fadeInLeft\':($index % 2 == 0)}\" data-ng-repeat=\"item in rest.items\"><div class=\"box-image\" data-in-view=\"rest[$index] = $inview\" data-ng-class=\"{ booktype: rest[$index]}\" data-ng-style=\"{\'background\': \'url(\' + item.imagen + \')\'}\"></div><div class=\"box-text\"><h4>ensalada</h4><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deleniti error exercitationem magni mollitia quas, quasi suscipit tempore temporibus ut voluptatem.</p><div class=\"iconf\"><span class=\"icon-food\"></span> <span class=\"icon-food\"></span></div></div></div></div></div><ng-include src=\"\'app/views/footer.html\'\"></ng-include>");
$templateCache.put("app/views/history/history.html","<ng-include src=\"\'app/views/header.html\'\"></ng-include><div class=\"container-fluid\"><div class=\"history\"><div class=\"hist-subt right\"><h2>SEAN <strong>BIENVENIDOS</strong></h2><div class=\"lineh hidden-xs hidden-sm\" data-in-view=\"hist.tit1 = $inview\" data-ng-class=\"{ draw: hist.tit1 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" xml:space=\"preserve\"><style type=\"text/css\">\n               .st0 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n          </style><g><line class=\"st0\" x1=\"400\" y1=\"3\" x2=\"0\" y2=\"3\"></line></g></svg></div></div><div class=\"hist-text wow fadeIn\" data-wow-delay=\".5s\"><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid, animi assumenda atque beatae cum dolorem dolorum eius impedit inventore magni nemo obcaecati quia quo reprehenderit similique tempore velit veritatis voluptatem.</p></div><div class=\"hist-img wow fadeIn\"><img src=\"../assets/images/history/01_edificio.png\" alt=\"\" class=\"hist-3d\"></div><div class=\"hist-subt LEFT\"><div class=\"lineh hidden-xs hidden-sm\" data-in-view=\"hist.tit2 = $inview\" data-ng-class=\"{ draw: hist.tit2 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" xml:space=\"preserve\"><style type=\"text/css\">\n               .st0 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n          </style><g><line class=\"st0\" x1=\"0\" y1=\"3\" x2=\"400\" y2=\"3\"></line></g></svg></div><h2><strong>TRADICION Y MODERNIDAD</strong><br>DESDE 1956</h2></div><div class=\"hist-img wow fadeIn hidden-xs hidden-sm\"><img src=\"../assets/images/history/02_edificio_antiguo.png\" alt=\"\" class=\"hist-3d\"></div><div class=\"hist-text wow fadeIn\" data-wow-delay=\".5s\"><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid, animi assumenda atque beatae cum dolorem dolorum eius impedit inventore magni nemo obcaecati quia quo reprehenderit similique tempore velit veritatis voluptatem.</p></div><div class=\"hist-img wow fadeIn hidden-md hidden-lg\"><img src=\"../assets/images/history/02_edificio_antiguo.png\" alt=\"\" class=\"hist-3d\"></div></div></div><ng-include src=\"\'app/views/footer.html\'\"></ng-include>");
$templateCache.put("app/views/home/banner.html","<div class=\"banner\" sliderhome=\"\"><div sliderhome=\"\" class=\"slide wow fadeIn\" data-ng-style=\"{\'background-image\': \'url(\' + slide.imagen + \')\'}\" data-ng-swipe-right=\"home.pickItem(\'prev\')\" data-ng-swipe-left=\"home.pickItem(\'next\')\" data-ng-if=\"$index == currentSli\" data-ng-repeat=\"slide in slider\"><div data-ng-click=\"pickItem(\'prev\')\" class=\"arroww left\"></div><div data-ng-click=\"pickItem(\'next\')\" class=\"arroww right\"></div><div class=\"social instagram\"></div><div class=\"social twitter\"></div><div class=\"social facebook\"></div></div></div><div class=\"banner\"><div class=\"home-title\" data-ng-init=\"home.htop1 = true\" data-in-view=\"home.htop1 = $inview\" data-ng-style=\"(home.htop1)?{\'top\': \'0\'}:{}\" data-wow-delay=\".7s\"><h1 class=\"htop\" data-ng-bind-html=\"switchText(\'La nueva<br>generación de\',\'The new <br>generation of\')\"></h1><h1 class=\"hbotom\" data-ng-bind-html=\"switchText(\'hoteles con<br>tradicion\',\'hotels with<br> tradition\')\"></h1></div><div class=\"reserve wow flipInY\" data-wow-delay=\"1.7s\"><form data-ng-submit=\"home.goReserve(home.reserve)\"><div class=\"dateinput\"><label data-ng-bind-html=\"switchText(\'LLEGADA\',\'ARRIVE\')\"></label> <input type=\"text\" data-ng-click=\"home.dp1 = !home.dp1\" data-ng-model=\"home.reserve.dateFrom\"> <a href=\"\" class=\"icon calendar\" data-ng-click=\"home.dp1 = !home.dp1\"></a><div class=\"date-box\" data-ng-if=\"home.dp1\"><div datepicker=\"\" data-ng-model=\"home.reserve.dateFrom\" class=\"well well-sm\" data-ng-change=\"home.dp1 = !home.dp1\" datepicker-options=\"home.options\"></div><div class=\"btn-theme\" data-ng-click=\"home.dp1 = !home.dp1\" data-ng-bind-html=\"switchText(\'CERRAR\',\'CLOSE\')\"></div></div></div><div class=\"dateinput\"><label data-ng-bind-html=\"switchText(\'PARTIDA\',\'DEPARTURE\')\"></label> <input type=\"text\" data-ng-click=\"home.dp2 = !home.dp2\" data-ng-model=\"home.reserve.dateTo\"> <a href=\"\" class=\"icon calendar\" data-ng-click=\"home.dp2 = !home.dp2\"></a><div class=\"date-box\" data-ng-if=\"home.dp2\"><div datepicker=\"\" data-ng-model=\"home.reserve.dateTo\" class=\"well well-sm\" required=\"\" data-ng-change=\"home.dp2 = !home.dp2\" datepicker-options=\"home.options\"></div><div class=\"btn-theme\" data-ng-click=\"home.dp2 = !home.dp2\" data-ng-bind-html=\"switchText(\'CERRAR\',\'CLOSE\')\"></div></div></div><div class=\"dateinput\"><label data-ng-bind-html=\"switchText(\'INVITADOS\',\'GUESTS\')\"></label> <input type=\"text\" required=\"\" data-ng-model=\"home.reserve.guests\"><div class=\"selector\"><span data-ng-click=\"home.setGuests(\'plus\')\" class=\"top\"></span> <span data-ng-click=\"home.setGuests(\'minus\')\" class=\"bottom\"></span></div></div><button class=\"btn btn-reserve\" type=\"submit\" data-ng-bind-html=\"switchText(\'RESERVAR\',\'RESERVE\')\"></button></form></div></div>");
$templateCache.put("app/views/home/comments.html","<div class=\"comments-title\"><div class=\"home-title\" data-sr=\"enter bottom over 2s after 0.5s and move 140px\"><h1 class=\"htop\" data-ng-bind-html=\"switchText(\'qué opinan\',\'What people said\')\"></h1><h1 class=\"hbotom\" data-ng-bind-html=\"switchText(\'de nosotros\',\'About us\')\"></h1></div></div><div class=\"comments\" data-ng-if=\"home.comments\"><ng-owl-carousel class=\"owl-theme\" owl-items=\"home.comments\" owl-properties=\"home.propertiesComments\" owl-ready=\"home.ready($api)\"><div class=\"item catprod\" data-ng-if=\"item.visible\" data-ng-repeat=\"item in home.comments\"><div class=\"content\"><strong data-ng-bind=\"item.nombre\"></strong><p data-ng-bind=\"item.comentario\"></p></div><div class=\"score\"><span data-ng-if=\"item.puntaje>=1\" class=\"glyphicon glyphicon-star\"></span> <span data-ng-if=\"item.puntaje>=2\" class=\"glyphicon glyphicon-star\"></span> <span data-ng-if=\"item.puntaje>=3\" class=\"glyphicon glyphicon-star\"></span> <span data-ng-if=\"item.puntaje>=4\" class=\"glyphicon glyphicon-star\"></span> <span data-ng-if=\"item.puntaje>=5\" class=\"glyphicon glyphicon-star\"></span> <span class=\"value\" data-ng-bind-html=\"item.puntaje\"></span></div><img src=\"../assets/images/icons/usuario.svg\" alt=\"\" class=\"profile\"></div></ng-owl-carousel><div class=\"col-xs-12\" style=\"text-align: center\"><button class=\"btn btn-theme\" data-ng-bind-html=\"switchText(\'DEJAR UN COMENTARIO\',\'LEAVE A COMMENT\')\">></button></div></div>");
$templateCache.put("app/views/home/gallery.html","<div class=\"galleryxs row\" data-ng-repeat=\"gal in home.gallery\"><ng-owl-carousel class=\"owl-theme\" owl-items=\"gal.items\" owl-properties=\"home.propertiesGallery\" owl-ready=\"home.ready($api)\"><div class=\"item catprod\" data-ng-repeat=\"item in gal.items\"><div class=\"img-gallery\" bottom-height-2=\"\" background=\"{{item.imagen}}\" data-ng-style=\"(home[gal.titulo])?{\'opacity\': \'1\'}:{}\"></div></div></ng-owl-carousel><div class=\"text\" data-ng-class=\"{\'type2\' : ( $index % 2 == 1)}\"><h2 class=\"title\" data-in-view=\"home[gal.titulo] = $inview\" data-ng-bind-html=\"gal.titulo\" data-ng-class=\"{ draw: home[gal.titulo] }\"></h2><div class=\"line\" data-ng-class=\"{ draw: home[gal.titulo] }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 200 6\" style=\"enable-background:new 0 0 200 6;\" xml:space=\"preserve\"><style type=\"text/css\">\n               .st0 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n               .st1 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n          </style><g><line class=\"st0\" x1=\"100\" y1=\"3\" x2=\"200\" y2=\"3\"></line><line class=\"st1\" x1=\"100\" y1=\"3\" x2=\"0\" y2=\"3\"></line></g></svg></div><p class=\"cont\" data-ng-bind-html=\"gal.contenido\"></p><a href=\"{{gal.enlace}}\" class=\"btn-theme\" data-ng-bind-html=\"switchText(\'ver más\',\'show more\')\"></a></div></div><div class=\"gallery hidden-xs\" data-ng-repeat=\"gal in home.gallery\"><div class=\"corousel\" data-ng-class=\"{\'type2\' : ( $index % 2 == 1)}\"><ng-owl-carousel class=\"owl-theme\" owl-items=\"gal.items\" owl-properties=\"home.propertiesGallery\" owl-ready=\"home.ready($api)\"><div class=\"item catprod\" data-ng-repeat=\"item in gal.items\"><div class=\"img-gallery\" bottom-height-2=\"\" background=\"{{item.imagen}}\" data-ng-style=\"(home[gal.titulo])?{\'opacity\': \'1\'}:{}\"></div></div></ng-owl-carousel></div><div class=\"text wow\" data-ng-class=\"{\'type2\' : ( $index % 2 == 1), \'slideInLeft\': ( $index % 2 != 1), \'slideInRight\': ( $index % 2 == 1)}\"><h2 class=\"title wow fadeIn\" data-ng-bind-html=\"gal.titulo\" data-ng-class=\"{ draw: home[gal.titulo] }\"></h2><div class=\"line\" data-in-view=\"home[gal.titulo] = $inview\" data-ng-class=\"{ draw: home[gal.titulo] }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 200 6\" style=\"enable-background:new 0 0 200 6;\" xml:space=\"preserve\"><style type=\"text/css\">\n               .st0 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n               .st1 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n          </style><g><line class=\"st0\" x1=\"100\" y1=\"3\" x2=\"200\" y2=\"3\"></line><line class=\"st1\" x1=\"100\" y1=\"3\" x2=\"0\" y2=\"3\"></line></g></svg></div><p class=\"cont\" data-ng-bind-html=\"gal.contenido\"></p><a href=\"{{gal.enlace}}\" ui-sref=\"($index==0)?promotions({lan: language}) || ($index==1)?restaurant({lan: language}) || ($index==2)?bar({lan: language})\" class=\"btn-theme\" data-ng-bind-html=\"switchText(\'ver más\',\'show more\')\"></a></div></div>");
$templateCache.put("app/views/home/promotions.html","<div class=\"promotions\" data-ng-if=\"home.promotions\"><h1 class=\"promtitle\" data-sr=\"enter bottom over 2s after 0.5s and move 140px\" data-ng-bind-html=\"switchText(\'PROMOCIONES <BR><STRONG>MITRU SUR</STRONG>\',\'PROMOTIONS <BR><STRONG>MITRU SUR</STRONG>\')\"></h1><ng-owl-carousel class=\"owl-theme\" owl-items=\"home.promotions\" owl-properties=\"home.propertiesPromotions\" owl-ready=\"home.ready($api)\"><div class=\"item catprod\" bottom-height=\"\" data-ng-repeat=\"item in home.promotions\"><div class=\"img\" bottom-height-2=\"\" background=\"{{item.imagen_small}}\"></div><p data-ng-bind=\"item.titulo\"></p><a href=\"{{gal.enlace}}\" ui-sref=\"promotions({lan: language})\" class=\"btn-theme\" data-ng-bind-html=\"switchText(\'ver más\',\'show more\')\"></a></div></ng-owl-carousel></div>");
$templateCache.put("app/views/home/where.html","<div class=\"map\"><div class=\"home-title\" data-in-view=\"home.htop2 = $inview\" data-ng-style=\"(home.htop2)?{\'top\': \'0\'}:{}\"><h1 class=\"htop\" data-ng-bind-html=\"switchText(\'Dónde\',\'Where\')\"></h1><h1 class=\"hbotom\" data-ng-bind-html=\"switchText(\'Encontrarnos\',\'To find us\')\"></h1></div><div sliderhome=\"\" class=\"home-map\"><ng-map sliderhome=\"\" center=\"-16.536400, -68.076022\" zoom=\"17\" styles=\'[{ \"featureType\": \"administrative\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": \"-100\"}] }, { \"featureType\": \"administrative.province\", \"elementType\": \"all\", \"stylers\": [{\"visibility\": \"off\"}] }, { \"featureType\": \"landscape\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": -100}, {\"lightness\": 65}, {\"visibility\": \"on\"}] }, { \"featureType\": \"poi\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": -100}, {\"lightness\": \"90\"}, {\"visibility\": \"off\"}] }, { \"featureType\": \"road\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": \"-100\"}]}, { \"featureType\": \"road.highway\", \"elementType\": \"all\", \"stylers\": [{\"visibility\": \"simplified\"}] }, { \"featureType\": \"road.arterial\", \"elementType\": \"all\", \"stylers\": [{\"lightness\": \"30\"}] }, { \"featureType\": \"road.local\", \"elementType\": \"all\", \"stylers\": [{\"lightness\": \"40\"}]}, { \"featureType\": \"transit\", \"elementType\": \"all\", \"stylers\": [{\"saturation\": -100}, {\"visibility\": \"simplified\"}] }, { \"featureType\": \"water\", \"elementType\": \"geometry\", \"stylers\": [{\"hue\": \"#ffff00\"}, {\"lightness\": -25}, {\"saturation\": -97}] }, { \"featureType\": \"water\", \"elementType\": \"labels\", \"stylers\": [{\"lightness\": -25}, {\"saturation\": -100}]}]\'><marker position=\"-16.536744, -68.076022\" title=\"Mitru Sur\" icon=\"../assets/images/icons/marker.png\"></marker></ng-map></div></div>");
$templateCache.put("app/views/promotions/promotions.html","<ng-include src=\"\'app/views/header.html\'\"></ng-include><div class=\"container-fluid\" windowheight=\"\"><div class=\"promotions2\"><div class=\"promo-title\"><h1>Promociones <strong>Mitru Sur</strong></h1></div><div class=\"promo-nav\"><ul class=\"options\"><li><a href=\"\" class=\"active\" data-ng-bind-html=\"switchText(\'TODOS\',\'ALL\')\"></a></li><li><a href=\"\" data-ng-bind-html=\"switchText(\'HABITACIONES\',\'ROOMS\')\"></a></li><li><a href=\"\" data-ng-bind-html=\"switchText(\'PLACERES CULINARIOS\',\'CULINARY PLEASURES\')\"></a></li><li><a href=\"\" data-ng-bind-html=\"switchText(\'ESPACIOS\',\'SPACES\')\"></a></li></ul></div><div class=\"promos\"><div class=\"box-image\"><div class=\"promoted\"></div><div class=\"offer wow flipInY\" data-wow-delay=\"1.5s\"><span data-ng-bind-html=\"switchText(\'NUEVA OFERTA !\',\'NEW OFFER !\')\"></span></div></div><div class=\"box-text\"><h3 class=\"title\" data-ng-class=\"{ draw: promo.item1 }\">Lorem ipsum.</h3><div class=\"line\" data-in-view=\"promo.item1 = $inview\" data-ng-class=\"{ draw: promo.item1 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 200 6\" style=\"enable-background:new 0 0 200 6;\" xml:space=\"preserve\"><style type=\"text/css\">\n               .st0 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n               .st1 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n          </style><g><line class=\"st0\" x1=\"100\" y1=\"3\" x2=\"200\" y2=\"3\"></line><line class=\"st1\" x1=\"100\" y1=\"3\" x2=\"0\" y2=\"3\"></line></g></svg></div><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium beatae doloribus eum, ipsa itaque nemo nesciunt odio quas repellat ullam!</p><div class=\"options\"><div><button class=\"btn icono like\"></button> <span class=\"like-text\" data-ng-bind-html=\"switchText(\'Me gusta\',\'like\')\"></span></div><button class=\"btn btn-theme\" data-ng-bind-html=\"switchText(\'Reservar\',\'Reserve\')\"></button><div><button class=\"btn icono share\"></button> <span class=\"share-text\" data-ng-bind-html=\"switchText(\'Reservar\',\'Share\')\"></span></div></div></div></div><div class=\"promos type2\"><div class=\"box-image\"><div class=\"promoted\"></div></div><div class=\"box-text\"><h3 class=\"title\" data-ng-class=\"{ draw: promo.item2 }\">Lorem ipsum.</h3><div class=\"line\" data-in-view=\"promo.item2 = $inview\" data-ng-class=\"{ draw: promo.item2 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 200 6\" style=\"enable-background:new 0 0 200 6;\" xml:space=\"preserve\"><style type=\"text/css\">\n               .st0 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n               .st1 {\n                 fill: none;\n                 stroke: #D1AC43;\n               }\n          </style><g><line class=\"st0\" x1=\"100\" y1=\"3\" x2=\"200\" y2=\"3\"></line><line class=\"st1\" x1=\"100\" y1=\"3\" x2=\"0\" y2=\"3\"></line></g></svg></div><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium beatae doloribus eum, ipsa itaque nemo nesciunt odio quas repellat ullam!</p><div class=\"options\"><div><button class=\"btn icono like\"></button> <span class=\"like-text\" data-ng-bind-html=\"switchText(\'Me gusta\',\'like\')\"></span></div><button class=\"btn btn-theme\" data-ng-bind-html=\"switchText(\'Reservar\',\'Reserve\')\"></button><div><button class=\"btn icono share\"></button> <span class=\"share-text\" data-ng-bind-html=\"switchText(\'Reservar\',\'Share\')\"></span></div></div></div></div></div></div><ng-include src=\"\'app/views/footer.html\'\"></ng-include>");
$templateCache.put("app/views/rooms/room.html","<ng-include src=\"\'app/views/loader.html\'\"></ng-include><ng-include src=\"\'app/views/header.html\'\"></ng-include><div class=\"container-fluid\"><div class=\"roomalbum\" windowheight=\"\" data-ng-if=\"room.items\"><ng-owl-carousel windowheight=\"\" class=\"owl-theme sliderhome\" owl-items=\"room.items\" owl-properties=\"room.properties\" owl-ready=\"room.ready($api)\"><div class=\"item catprod\" windowheight=\"\" data-ng-repeat=\"item in room.items\"><h1 class=\"itemtitle\">Standar</h1><div class=\"img-gallery\" windowheight=\"\" data-ng-style=\"{\'background\': \'url(\' + item.imagen + \')\'}\"></div></div></ng-owl-carousel><div class=\"social instagram\"></div><div class=\"social twitter\"></div><div class=\"social facebook\"></div><div class=\"promogold wow slideInUp\" data-wow-delay=\"1s\"><span data-ng-bind-html=\"switchText(\'RESERVA YA\',\'RESERVE NOW\')\"></span></div></div><div class=\"roomfeatures\" data-ng-if=\"room.items\"><div class=\"boxfeat left\" data-in-view=\"room.draw1 = $inview\"><div class=\"tline\" data-ng-class=\"{ draw: room.draw1 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 142.5 24.9\" style=\"enable-background:new 0 0 142.5 24.9;\" xml:space=\"preserve\"><style type=\"text/css\">\n          .st0 {\n            fill: none;\n            stroke: #D1AC43;\n            stroke-miterlimit: 10;\n          }\n\n          .st1 {\n            fill: none;\n            stroke: #D1AC43;\n            stroke-miterlimit: 10;\n          }\n\n          .st2 {\n            fill: none;\n            stroke: #D1AC43;\n            stroke-miterlimit: 10;\n          }\n        </style><g><line class=\"st0\" x1=\"0\" y1=\"12.4\" x2=\"142.5\" y2=\"12.4\"></line><line class=\"st1\" x1=\"142.5\" y1=\"12.4\" x2=\"142.5\" y2=\"0\"></line><line class=\"st2\" x1=\"142.5\" y1=\"12.4\" x2=\"142.5\" y2=\"24.9\"></line></g></svg></div><h2 class=\"title\" data-ng-class=\"{ draw: room.draw1 }\">Standar</h2></div><div class=\"boxfeat center\" data-in-view=\"room.draw2 = $inview\"><p class=\"roomdesc wow slideInLeft\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip</p><div class=\"tline2\" data-ng-class=\"{ draw2: room.draw2 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 16 220\" style=\"enable-background:new 0 0 16 220;\" xml:space=\"preserve\"><style type=\"text/css\">\n            .st0{fill:none;stroke:#D1AC43;}\n          </style><line class=\"st0\" x1=\"8\" y1=\"220\" x2=\"8\" y2=\"8\"></line></svg></div></div><div class=\"boxfeat right\" data-in-view=\"room.draw3 = $inview\"><div class=\"tline2\" data-ng-class=\"{ draw3: room.draw3 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 16 220\" style=\"enable-background:new 0 0 16 220;\" xml:space=\"preserve\"><style type=\"text/css\">\n            .st0{fill:none;stroke:#D1AC43;}\n          </style><line class=\"st0\" x1=\"8\" y1=\"220\" x2=\"8\" y2=\"8\"></line></svg></div><ul class=\"room-features wow slideInLeft\"><li><strong>Capacidad:</strong> 1 ó 2 personas <span class=\"icon\"></span></li><li><strong>Capacidad:</strong> 1 ó 2 personas <span class=\"icon\"></span></li><li><strong>Capacidad:</strong> 1 ó 2 personas <span class=\"icon\"></span></li></ul><button class=\"btn btn-theme wow slideInLeft\" data-ng-bind-html=\"switchText(\'RESERVA YA\',\'RESERVE\')\"></button></div></div></div><ng-include src=\"\'app/views/rooms/services.html\'\"></ng-include><ng-include src=\"\'app/views/footer.html\'\"></ng-include>");
$templateCache.put("app/views/rooms/roomshome.html","<ng-include src=\"\'app/views/loader.html\'\"></ng-include><ng-include src=\"\'app/views/header.html\'\"></ng-include><div windowheight=\"\" class=\"rooms container-fluid\"><div class=\"title wow fadeIn\"><h1 class=\"rooms-title\" data-ng-bind-html=\"switchText(\'Porque te mereces <strong>lo mejor</strong>\',\'Because you deserve <strong>the best</strong>\')\"></h1></div><div class=\"rooms\"><div class=\"room-box wow fadeInDown\" data-wow-delay=\"1s\" data-ng-repeat=\"item in rooms.rooms\" data-ng-if=\"$index <= 2\"><div class=\"box2\" ui-sref=\"roomalbum({lan: language})\"><div class=\"image\" data-ng-class=\"{ eng: language==\'en\' }\" data-ng-style=\"{\'background-image\': \'url(\' + item.imagen + \')\'}\"></div><div class=\"text\"><h4 class=\"subtitle\">Suite<div class=\"line\" data-in-view=\"rooms[$index] = $inview\" data-ng-class=\"{ draw: rooms[$index] }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 200 6\" style=\"enable-background:new 0 0 200 6;\" xml:space=\"preserve\"><style type=\"text/css\">\n                   .st0 {\n                     fill: none;\n                     stroke: #D1AC43;\n                   }\n                   .st1 {\n                     fill: none;\n                     stroke: #D1AC43;\n                   }\n              </style><g><line class=\"st0\" x1=\"100\" y1=\"3\" x2=\"200\" y2=\"3\"></line><line class=\"st1\" x1=\"100\" y1=\"3\" x2=\"0\" y2=\"3\"></line></g></svg></div></h4><p class=\"desc\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh</p><p class=\"features\"><strong>capacidad:</strong> 1 ó 2 personas <span class=\"icon\"></span></p></div><a href=\"\" class=\"btn btn-theme\" data-ng-bind-html=\"switchText(\'RESERVA YA\',\'RESERVE NOW\')\"></a></div><div class=\"triangle\"></div></div></div><div class=\"rooms\"><div class=\"room-box wow fadeInDown\" data-ng-repeat=\"item in rooms.rooms\" data-ng-if=\"$index > 2\"><div class=\"box2\"><div class=\"image\" data-ng-class=\"{ eng: language==\'en\' }\" data-ng-style=\"{\'background-image\': \'url(\' + item.imagen + \')\'}\"></div><div class=\"text\"><h4 class=\"subtitle\">Suite<div class=\"line\" data-in-view=\"rooms[$index] = $inview\" data-ng-class=\"{ draw: rooms[$index] }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 200 6\" style=\"enable-background:new 0 0 200 6;\" xml:space=\"preserve\"><style type=\"text/css\">\n                   .st0 {\n                     fill: none;\n                     stroke: #D1AC43;\n                   }\n                   .st1 {\n                     fill: none;\n                     stroke: #D1AC43;\n                   }\n              </style><g><line class=\"st0\" x1=\"100\" y1=\"3\" x2=\"200\" y2=\"3\"></line><line class=\"st1\" x1=\"100\" y1=\"3\" x2=\"0\" y2=\"3\"></line></g></svg></div></h4><p class=\"desc\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh</p><p class=\"features\"><strong>capacidad:</strong> 1 ó 2 personas <span class=\"icon\"></span></p></div><a href=\"\" class=\"btn btn-theme\" data-ng-bind-html=\"switchText(\'RESERVA YA\',\'RESERVE NOW\')\"></a></div><div class=\"triangle\"></div></div></div></div><ng-include src=\"\'app/views/rooms/services.html\'\"></ng-include><ng-include src=\"\'app/views/footer.html\'\"></ng-include>");
$templateCache.put("app/views/rooms/services.html","<div data-ng-controller=\"ServicesController as serv\"><div class=\"container-fluid\" data-ng-if=\"serv.services\"><div class=\"row wow slideInLeft\" data-wow-duration=\"1.5s\"><div class=\"servtitle\" data-ng-if=\"currentState == \'roomalbum\' || currentState == \'rooms\'\"><h1>LAS MEJORES HABITACIONES <strong>SON PARA TÍ</strong></h1><h3>servicios incluidos:</h3></div><div class=\"servtitle\" data-ng-if=\"currentState == \'spacealbum\' || currentState == \'spaces\'\"><h1>PORQUE TE MERECES <strong>AÚN MÁS</strong></h1><h3>Servicios con costo adicional:</h3></div></div></div><div class=\"container\"><div class=\"carousel-services\" data-ng-if=\"serv.services\"><div class=\"item-services\" boucle=\"\" index=\"$index\" alldata=\"serv.services.length\" data-ng-repeat=\"item in serv.services\"><div class=\"icon-box\" data-ng-click=\"sliderOp.move($index)\"><div class=\"icon\" data-ng-style=\"{\'background\': \'url(\' + item.icono + \') center no-repeat\'}\"></div><div class=\"litem\"><p data-ng-bind=\"item.nombre\"></p></div></div></div></div></div><div class=\"clearfix\"></div><div class=\"container-fluid\"><div class=\"clearfix\"></div><div class=\"list-services\"><div class=\"list-box\"><ul><li class=\"wow fadeInUp\" data-wow-delay=\"{{($index+1)/10}}s\" data-ng-repeat=\"item in serv.services\"><p data-ng-bind=\"item.nombre\"></p></li></ul></div></div></div></div>");
$templateCache.put("app/views/spaces/space.html","<ng-include src=\"\'app/views/loader.html\'\"></ng-include><ng-include src=\"\'app/views/header.html\'\"></ng-include><div class=\"container-fluid\"><div class=\"roomalbum\" windowheight=\"\"><ng-owl-carousel windowheight=\"\" class=\"owl-theme sliderhome\" owl-items=\"space.items\" owl-properties=\"properties\" owl-ready=\"space.ready($api)\"><div class=\"item catprod\" windowheight=\"\" data-ng-repeat=\"item in space.items\"><div class=\"img-gallery\" windowheight=\"\" data-ng-style=\"{\'background\': \'url(\' + item.imagen + \')\'}\"><h5>SPA</h5></div></div></ng-owl-carousel><div class=\"social instagram\"></div><div class=\"social twitter\"></div><div class=\"social facebook\"></div></div><div class=\"roomfeatures\"><div class=\"boxfeat left\" data-in-view=\"space.draw1 = $inview\"><div class=\"tline\" data-ng-class=\"{ draw: space.draw1 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 142.5 24.9\" style=\"enable-background:new 0 0 142.5 24.9;\" xml:space=\"preserve\"><style type=\"text/css\">\n          .st0 {\n            fill: none;\n            stroke: #D1AC43;\n            stroke-miterlimit: 10;\n          }\n\n          .st1 {\n            fill: none;\n            stroke: #D1AC43;\n            stroke-miterlimit: 10;\n          }\n\n          .st2 {\n            fill: none;\n            stroke: #D1AC43;\n            stroke-miterlimit: 10;\n          }\n        </style><g><line class=\"st0\" x1=\"0\" y1=\"12.4\" x2=\"142.5\" y2=\"12.4\"></line><line class=\"st1\" x1=\"142.5\" y1=\"12.4\" x2=\"142.5\" y2=\"0\"></line><line class=\"st2\" x1=\"142.5\" y1=\"12.4\" x2=\"142.5\" y2=\"24.9\"></line></g></svg></div><h2 class=\"title\" data-ng-class=\"{ draw: space.draw1 }\">PISCINA & SAUNAS</h2></div><div class=\"boxfeat center\" data-in-view=\"space.draw2 = $inview\"><p class=\"roomdesc wow slideInLeft\"><strong>Piscina</strong><br>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh Lorem ipsum dolor sit amet, consectetuer</p><p class=\"roomdesc wow slideInLeft\"><strong>Sauna</strong><br>Sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip</p><div class=\"tline2\" data-ng-class=\"{ draw2: space.draw2 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 16 220\" style=\"enable-background:new 0 0 16 220;\" xml:space=\"preserve\"><style type=\"text/css\">\n            .st0{fill:none;stroke:#D1AC43;}\n          </style><line class=\"st0\" x1=\"8\" y1=\"220\" x2=\"8\" y2=\"8\"></line></svg></div></div><div class=\"boxfeat right\" data-in-view=\"space.draw3 = $inview\"><div class=\"tline2\" data-ng-class=\"{ draw3: space.draw3 }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 16 220\" style=\"enable-background:new 0 0 16 220;\" xml:space=\"preserve\"><style type=\"text/css\">\n            .st0{fill:none;stroke:#D1AC43;}\n          </style><line class=\"st0\" x1=\"8\" y1=\"220\" x2=\"8\" y2=\"8\"></line></svg></div><ul class=\"room-features space wow slideInLeft\"><li><strong style=\"color: #d1ac43;\">PISCINA</strong><br><strong>Capacidad:</strong> 1 ó 2 personas <span class=\"icon\"></span></li><li><strong style=\"color: #d1ac43;\">SAUNA</strong><br><strong>Capacidad:</strong> 1 ó 2 personas <span class=\"icon\"></span></li></ul><button class=\"btn btn-theme wow slideInLeft\" data-ng-bind-html=\"switchText(\'RESERVA YA\',\'RESERVE\')\"></button></div></div></div><ng-include src=\"\'app/views/rooms/services.html\'\"></ng-include><ng-include src=\"\'app/views/footer.html\'\"></ng-include>");
$templateCache.put("app/views/spaces/spaceshome.html","<ng-include src=\"\'app/views/loader.html\'\"></ng-include><ng-include src=\"\'app/views/header.html\'\"></ng-include><div windowheight=\"\" class=\"rooms container-fluid\"><div class=\"title wow fadeIn\"><h1 class=\"rooms-title\" data-ng-bind-html=\"switchText(\'Porque tu entretenimiento<br><strong>es importante</strong>\',\'Because your entertaiment<br><strong>is important</strong>\')\"></h1></div><div class=\"rooms\"><div class=\"room-box wow fadeInDown\" data-wow-delay=\"1s\" data-ng-repeat=\"item in spaces.rooms\" data-ng-if=\"$index <= 2\"><div class=\"box2\"><div class=\"image\" ui-sref=\"spacealbum({lan: language})\" data-ng-class=\"{ eng: language==\'en\' }\" data-ng-style=\"{\'background-image\': \'url(\' + item.imagen + \')\'}\"></div><div class=\"text\"><h4 class=\"subtitle\">SPA<div class=\"line\" data-in-view=\"rooms[$index] = $inview\" data-ng-class=\"{ draw: rooms[$index] }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 200 6\" style=\"enable-background:new 0 0 200 6;\" xml:space=\"preserve\"><style type=\"text/css\">\n                   .st0 {\n                     fill: none;\n                     stroke: #D1AC43;\n                   }\n                   .st1 {\n                     fill: none;\n                     stroke: #D1AC43;\n                   }\n              </style><g><line class=\"st0\" x1=\"100\" y1=\"3\" x2=\"200\" y2=\"3\"></line><line class=\"st1\" x1=\"100\" y1=\"3\" x2=\"0\" y2=\"3\"></line></g></svg></div></h4><p class=\"desc\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh</p></div><a href=\"\" class=\"btn btn-theme\" data-ng-bind-html=\"switchText(\'RESERVA YA\',\'RESERVE NOW\')\"></a></div><div class=\"triangle\"></div></div></div><div class=\"rooms\"><div class=\"room-box wow fadeInDown\" data-ng-repeat=\"item in spaces.rooms\" data-ng-if=\"$index > 2\"><div class=\"box2\"><div class=\"image\" ui-sref=\"spacealbum({lan: language})\" data-ng-class=\"{ eng: language==\'en\' }\" data-ng-style=\"{\'background-image\': \'url(\' + item.imagen + \')\'}\"></div><div class=\"text\"><h4 class=\"subtitle\">SPA<div class=\"line\" data-in-view=\"rooms[$index] = $inview\" data-ng-class=\"{ draw: rooms[$index] }\"><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 200 6\" style=\"enable-background:new 0 0 200 6;\" xml:space=\"preserve\"><style type=\"text/css\">\n                   .st0 {\n                     fill: none;\n                     stroke: #D1AC43;\n                   }\n                   .st1 {\n                     fill: none;\n                     stroke: #D1AC43;\n                   }\n              </style><g><line class=\"st0\" x1=\"100\" y1=\"3\" x2=\"200\" y2=\"3\"></line><line class=\"st1\" x1=\"100\" y1=\"3\" x2=\"0\" y2=\"3\"></line></g></svg></div></h4><p class=\"desc\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh</p></div><a href=\"\" class=\"btn btn-theme\" data-ng-bind-html=\"switchText(\'RESERVA YA\',\'RESERVE NOW\')\"></a></div><div class=\"triangle\"></div></div></div></div><ng-include src=\"\'app/views/rooms/services.html\'\"></ng-include><ng-include src=\"\'app/views/footer.html\'\"></ng-include>");
$templateCache.put("app/views/directives/bigslide/bigslide.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title></title></head><body></body></html>");}]);